/** Ortak ve hata metinleri (ar); panel, vitrin ve API birlikte kullanır (F7-17'de ayrıldı). */
import { faz8ErrorsAr } from './faz8.ar';
import { aiErrorsAr } from './ai.errors.ar';

export const commonAr = {
  appName: 'Zootopia Panel',
  save: 'حفظ',
  cancel: 'إلغاء',
  done: 'تم',
  delete: 'حذف',
  edit: 'تعديل',
  create: 'إنشاء',
  add: 'إضافة',
  close: 'إغلاق',
  back: 'رجوع',
  previous: 'السابق',
  next: 'التالي',
  confirm: 'تأكيد',
  loading: 'جارٍ التحميل…',
  saved: 'تم الحفظ',
  yes: 'نعم',
  no: 'لا',
  none: 'لا يوجد',
  all: 'الكل',
  status: 'الحالة',
  actions: 'الإجراءات',
  name: 'الاسم',
  email: 'البريد الإلكتروني',
  password: 'كلمة المرور',
  search: 'بحث',
  copy: 'نسخ',
  copied: 'تم النسخ',
  optional: 'اختياري',
  required: 'مطلوب',
  noData: 'لا توجد بيانات بعد',
  unknown: 'غير معروف',
  retry: 'أعد المحاولة',
  help: 'مساعدة',
  whatIsThisPage: 'ما فائدة هذه الصفحة؟',
  lockedPhase: 'متاح في المرحلة {{phase}}',
  createdAt: 'تاريخ الإنشاء',
  updatedAt: 'آخر تحديث',
  lastUsed: 'آخر استخدام',
  never: 'أبدًا',
  signOut: 'تسجيل الخروج',
  modeBeginner: 'وضع المبتدئ',
  modeAdvanced: 'الوضع المتقدم',
  language: 'اللغة',
  theme: 'المظهر',
  themeLight: 'فاتح',
  themeDark: 'داكن',
  themeSystem: 'النظام',
  reveal: 'إظهار',
  days: '{{count}} يوم',
  more: 'تحميل المزيد',
  remove: 'إزالة',
  deleted: 'تم الحذف',
};

// Faz 8 hata metinleri ayrı dosyada; tek satırla eklenir (ADR-801).
export const errorsAr = {
  ...faz8ErrorsAr,
  ...aiErrorsAr,
  section_type_unavailable: 'نوع القسم هذا غير متاح بعد.',
  section_target_missing: 'لم يُعثر على الفئة أو المنتج المحدد؛ اختر غيره.',
  section_image_required: 'ارفع صورة لهذا القسم.',
  banner_image_required: 'ارفع صورة لسطح المكتب لموضع العرض هذا.',
  question_too_short: 'يجب ألا يقل سؤالك عن 10 أحرف.',
  question_answer_required: 'اكتب إجابة قبل النشر.',
  favorites_full: 'قائمة المفضلة ممتلئة (200 منتج كحد أقصى)؛ أزل بعض المنتجات لإضافة المزيد.',
  post_published_delete: 'لا يمكن حذف مقالة منشورة؛ يمكنك إلغاء نشرها.',
  post_body_required: 'اكتب نص المقالة قبل النشر.',
  banner_text_required: 'اكتب نصًا لموضع العرض هذا.',
  banner_image_not_allowed: 'شريط الإعلانات لا يستخدم صورًا.',
  banner_link_required: 'أدخل عنوان رابط لنص الزر.',
  end_before_start: 'يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء.',
  banner_active_delete: 'لا يمكن حذف لافتة نشطة؛ أوقفها أولًا.',
  banner_order_mismatch:
    'قائمة الترتيب لا تطابق اللافتات في موضع العرض هذا؛ أعد تحميل الصفحة وحاول مرة أخرى.',
  content_file_missing: 'لم يُعثر على صورة في المحتوى؛ ارفعها مرة أخرى.',
  unpublish_before_publish: 'يجب أن يكون تاريخ إلغاء النشر بعد تاريخ النشر.',
  page_home_exists: 'لهذا المتجر صفحة رئيسية بهذه اللغة بالفعل.',
  locale_not_in_store: 'هذه اللغة ليست ضمن أسواق المتجر. أضف أولًا سوقًا بهذه اللغة من شاشة «المتاجر».',
  locale_unsupported: 'هذه اللغة غير مدعومة (اختر التركية أو الإنجليزية أو الألمانية أو العربية).',
  translation_same_locale: 'يجب أن تكون الترجمة بلغة غير لغة المحتوى الأصلية.',
  translation_exists: 'يوجد لهذا المحتوى ترجمة بهذه اللغة بالفعل؛ افتحها من مرشّح اللغة.',
  content_locale_mismatch: 'المحتوى المحدد بلغة أخرى؛ اختر الصفحة أو المقالة أو الفئة بهذه اللغة.',
  page_published_delete: 'لا يمكن حذف صفحة منشورة (يُحتفظ بسجلها)؛ ألغِ نشرها بدلًا من ذلك.',
  content_review_required: 'يوجد محتوى صحي أو ادعاء صحي: يتطلب النشر موافقة المراجع البيطري المختص.',
  content_review_rejected: 'رُفض المحتوى في مراجعة المختص؛ صحّحه وأرسله للمراجعة مرة أخرى.',
  content_review_not_required: 'لا يحتاج هذا المحتوى إلى موافقة المختص.',
  invalid_item_id: 'معرّف عنصر القائمة غير صالح؛ أعد تحميل الصفحة وحاول مرة أخرى.',
  duplicate_item_id: 'أُضيف عنصر القائمة نفسه مرتين؛ أعد تحميل الصفحة وحاول مرة أخرى.',
  menu_too_deep: 'لا يمكن تداخل القائمة أعمق من ذلك هنا (الترويسة 3 مستويات، والتذييل مستويان).',
  menu_item_link_required: 'يحتاج عنصر القائمة الذي لا يحتوي على عناصر فرعية إلى رابط.',
  menu_too_many_items: 'يمكن أن تحتوي القائمة على 150 عنصرًا كحد أقصى.',
  menu_target_missing: 'لم يُعثر على الفئة أو المنتج المرتبط؛ اختر هدفًا آخر.',
  theme_no_draft: 'لا توجد مسودة سمة للنشر. احفظ المسودة أولًا.',
  theme_draft_invalid: 'تعذّرت قراءة مسودة السمة؛ احفظها مجددًا في المحرر.',
  theme_contrast_failed:
    'لا يمكن نشر السمة: عدد أزواج الألوان غير المقروءة بما يكفي: {{count}}. أصلح التحذيرات في المحرر.',
  theme_no_changes: 'هذه السمة منشورة بالفعل؛ لا توجد تغييرات.',
  theme_dark_palette_required: 'يلزم تحديد ألوان داكنة لاتباع الوضع الداكن للجهاز.',
  theme_preview_invalid: 'انتهت صلاحية رابط المعاينة أو أنه غير صالح. احصل على رابط جديد من لوحة التحكم.',
  store_domain_missing: 'لا يوجد نطاق لواجهة المتجر. أضف نطاقًا من شاشة «المتاجر».',
  color_format: 'يجب أن يكون اللون بصيغة #RRGGBB (مثل #0d5a4e).',
  content_invalid: 'تعذّرت قراءة المحتوى؛ احفظه مجددًا في المحرر.',
  content_unknown_node: 'يحتوي المحتوى على عنصر غير مسموح به (مثل HTML ملصق أو برنامج نصي).',
  content_invalid_link: 'رابط غير صالح. استخدم https://… أو mailto: أو tel: أو مسارًا داخل الموقع يبدأ بـ /.',
  content_image_alt_required: 'النص البديل الذي يصف الصورة مطلوب (لقارئات الشاشة ومحركات البحث).',
  content_too_large: 'المحتوى طويل جدًا. قسّمه على عدة صفحات أو مقالات.',
  content_too_deep: 'القائمة متداخلة بعمق كبير؛ يُسمح بأربعة مستويات كحد أقصى.',
  content_video_title_required: 'عنوان الفيديو مطلوب (تُعرِّف قارئات الشاشة المشغّل به).',
  invalid_section_id: 'معرّف القسم غير صالح.',
  duplicate_section_id: 'أُضيف القسم نفسه مرتين؛ أعد تحميل الصفحة وحاول مرة أخرى.',
  section_category_required: 'اختر فئة لهذا القسم.',
  section_collection_required: 'اختر مجموعة لهذا القسم.',
  section_brand_required: 'اختر علامة تجارية لهذا القسم.',
  section_products_required: 'اختر منتجًا واحدًا على الأقل لهذا القسم.',
  unauthenticated: 'يجب تسجيل الدخول.',
  invalid_credentials: 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
  account_locked: 'محاولات فاشلة كثيرة. تم قفل الحساب لمدة {{minutes}} دقيقة.',
  mfa_required: 'رمز التحقق مطلوب.',
  mfa_setup_required: 'يجب إعداد التحقق بخطوتين للمتابعة.',
  mfa_invalid: 'رمز التحقق غير صحيح أو منتهي الصلاحية.',
  mfa_already_enrolled: 'التحقق بخطوتين مُعدّ بالفعل.',
  mfa_enrollment_not_started: 'ابدأ إعداد تطبيق المصادقة أولًا.',
  step_up_required: 'يرجى إدخال رمز التحقق مرة أخرى لهذا الإجراء.',
  forbidden: 'ليست لديك صلاحية لهذا الإجراء.',
  not_found: 'السجل غير موجود.',
  merchant_market_required: 'اختر سوقًا واحدًا على الأقل.',
  translation_base_locale: 'لا تُحفظ ترجمة للغة الأساسية؛ عدّل حقول المنتج أو الفئة نفسها بدلًا من ذلك.',
  market_country_mismatch:
    'يجب أن يكون عنوان التسليم في بلد السوق المحدد. للشحن إلى بلد آخر اختره من أعلى الصفحة.',
  tax_rate_missing:
    'لا يمكن استلام طلبات لهذا البلد لعدم تحديد نسبة ضريبة القيمة المضافة. يرجى التواصل مع المتجر.',
  export_exempt_domestic: 'لا يمكن استخدام إعفاء التصدير إلا في سوق خارجي.',
  hs_code_format: 'يجب أن يتكون رمز النظام المنسق (HS) من 6 إلى 12 رقمًا.',
  order_cancelled: 'لا يمكن إنشاء هذا المستند لطلب ملغى.',
  store_not_found: 'لا يوجد متجر مرتبط بهذا النطاق.',
  conflict: 'يتعارض الإجراء مع سجل موجود.',
  version_mismatch: 'قام شخص آخر بتعديل هذا السجل أثناء تحريرك. حدّث الصفحة وحاول مرة أخرى.',
  validation_failed: 'بعض الحقول غير صالحة.',
  bad_request: 'طلب غير صالح.',
  token_invalid: 'الرابط غير صالح أو منتهي الصلاحية.',
  no_organization: 'حسابك غير مرتبط بمنشأة نشطة.',
  rate_limited: 'طلبات كثيرة جدًا. يرجى الانتظار قليلًا ثم المحاولة مرة أخرى.',
  idempotency_key_required: 'ترويسة Idempotency-Key مطلوبة لهذا الإجراء.',
  idempotency_conflict: 'استُخدم Idempotency-Key نفسه مع طلب مختلف.',
  idempotency_in_progress: 'تجري معالجة الطلب نفسه حاليًا.',
  csrf_failed: 'فشل التحقق الأمني. أعد تحميل الصفحة وحاول مرة أخرى.',
  internal: 'حدث خطأ غير متوقع. رمز الخطأ: {{requestId}}',
  slug_taken: 'هذا الاسم المختصر مستخدم بالفعل.',
  code_taken: 'هذا الرمز مستخدم بالفعل.',
  hostname_taken: 'هذا النطاق مسجّل لمتجر آخر.',
  market_exists: 'هذه التركيبة من البلد واللغة والعملة موجودة بالفعل.',
  cannot_remove_default_market: 'لا يمكن إزالة السوق الافتراضي؛ اجعل سوقًا آخر افتراضيًا أولًا.',
  already_member: 'هذا الشخص عضو بالفعل.',
  last_owner: 'يجب أن يبقى في المنشأة مالك نشط واحد على الأقل.',
  role_in_use: 'هذا الدور مُسند إلى مستخدمين ({{count}})؛ غيّر أدوارهم أولًا.',
  role_name_taken: 'يوجد دور بهذا الاسم بالفعل.',
  integration_not_available_yet:
    'سيُضاف هذا التكامل في المرحلة {{phase}}. لا يمكن إدخال بيانات الاعتماد بعد.',
  integration_not_configured: 'احفظ بيانات الاتصال أولًا.',
  setup_step_locked: 'تُفتح هذه الخطوة في المرحلة {{phase}}.',
  invalid_email: 'أدخل بريدًا إلكترونيًا صالحًا.',
  file_too_large: 'الملف كبير جدًا (الحد الأقصى {{maxMb}} MB).',
  file_type_not_allowed: 'لا يمكن رفع هذا النوع من الملفات.',
  template_name_taken: 'يوجد قالب بهذا الاسم بالفعل.',
  sku_pattern_no_token: 'يجب أن يحتوي النمط على عنصر نائب واحد على الأقل (مثل {marka}).',
  sku_pattern_unknown_token: 'عنصر نائب غير معروف. المتاح: {marka} {kategori} {urun} {secenek} {sira}.',
  sku_pattern_invalid: 'يُسمح فقط بالأحرف والأرقام والعناصر النائبة والرموز - _ . /',
  schedule_in_past: 'يجب أن يكون وقت النشر بعد دقيقة واحدة على الأقل من الآن.',
  schedule_too_far: 'يمكن جدولة النشر لمدة أقصاها سنة واحدة مقدمًا.',
  listing_already_published: 'المنتج منشور بالفعل في هذا المتجر.',
  bulk_too_many: 'الحد الأقصى للمنتجات في الإجراء الجماعي هو {{max}}. ضيّق عامل التصفية.',
  collection_not_manual: 'لا يمكن إضافة منتجات يدويًا إلى مجموعة قائمة على القواعد؛ غيّر قواعدها.',
  lot_tracked: 'يُتتبَّع هذا المتغيّر بالدفعة/تاريخ انتهاء الصلاحية؛ أدخل المخزون من شاشة المخزون.',
  stock_below_reserved: 'لا يمكن أن ينخفض المخزون عن الكمية المحجوزة للطلبات.',
  lot_required: 'المخزون في هذا المستودع مُدار بالدفعات؛ اختر الدفعة (أو «مخزون بلا دفعة»).',
  import_not_finished: 'لم يكتمل الاستيراد بعد؛ يمكنك إعادة المحاولة عند اكتماله.',
  import_nothing_to_retry: 'لا يوجد ما تُعاد محاولته؛ تم تطبيق جميع المنتجات.',
  import_json_invalid: 'تعذّرت قراءة ملف JSON. تأكد من أنه بصيغة JSON صالحة.',
  import_doc_field_invalid: 'هذه القيمة لا تطابق مخطط مستند المنتج.',
  xml_invalid: 'تعذّرت قراءة ملف XML (خطأ في التنسيق).',
  xml_doctype_not_allowed: 'لأسباب أمنية، لا يُقبل XML الذي يحتوي على تعريفات DOCTYPE أو ENTITY.',
  column_map_invalid: 'تعذّرت قراءة مطابقة الأعمدة.',
  fx_same_currency: 'في السعر المعتمد على سعر الصرف يجب أن تكون القائمة المصدر بعملة أخرى.',
  rate_format: 'أدخل سعر الصرف بصيغة 34.1250، أكبر من الصفر وبحد أقصى 8 خانات عشرية.',
  price_list_derived:
    'هذه القائمة مشتقة من أسعار الصرف، وتُحسب أسعارها من القائمة الأساسية. غيّر السعر في القائمة الأساسية أو أعد القائمة إلى الأسعار اليدوية.',
  card_currency_unsupported: 'لا يقبل {{provider}} الدفع بالبطاقة بعملة {{currency}}.',
  fx_base_missing: 'لم يُعثر على القائمة الأساسية لهذه القائمة المشتقة من سعر الصرف.',
  fx_rate_unavailable:
    'لا يوجد سعر صرف من TCMB بالنوع المحدد لعملة {{currency}} (لم يُجلب بعد أو لا يُنشر لهذا النوع). لا تُختلق الأسعار أبدًا: اختر نوع سعر آخر أو أعد الحساب عند وصول الأسعار.',
  fx_list_is_base: 'تُشتق قوائم أخرى من هذه القائمة، لذا لا يمكن اشتقاقها هي نفسها.',
  fx_not_configured: 'هذه القائمة غير مشتقة من أسعار الصرف.',
  fx_base_self: 'لا يمكن اشتقاق قائمة من نفسها؛ اختر قائمة أساسية أخرى.',
  fx_base_derived: 'لا يمكن أن تكون القائمة الأساسية مشتقة من سعر الصرف؛ اختر قائمة بأسعار يدوية.',
  country_format: 'يجب أن يتكون رمز البلد من حرفين (مثل DE).',
  market_currency_mismatch: 'يجب أن تطابق عملة السوق عملة القائمة.',
  customer_or_email_required: 'اختر عميلًا مسجّلًا أو أدخل بريدًا إلكترونيًا لطلب زائر.',
  discount_conflict: 'لا يمكن الجمع بين رمز الخصم والخصم اليدوي؛ اختر أحدهما.',
  draft_only_field: 'لا يمكن تغيير العميل والشحن والخصم وطريقة الدفع إلا في طلب مسودة.',
  order_closed: 'الطلب مغلق (مكتمل أو ملغى) ولا يمكن تغييره.',
  order_shipped: 'تم شحن الطلب؛ لم يعد بالإمكان تغيير المنتجات والعنوان.',
  order_paid: 'تم استلام الدفع؛ لا يمكن تغيير المنتجات والكميات. يمكن تغيير العنوان والملاحظة فقط.',
  order_invoiced: 'صدرت فاتورة للطلب؛ لا يمكن تغيير المنتجات وعنوان الفاتورة. ألغِ الفاتورة أولًا.',
  order_payment_in_progress: 'يدفع العميل بالبطاقة الآن؛ لا يمكن تغيير المنتجات حتى اكتمال الدفع.',
  payment_link_expired: 'انتهت صلاحية رابط الدفع. تواصل مع البائع للحصول على رابط جديد.',
  payment_link_cancelled: 'أُلغي رابط الدفع هذا. تواصل مع البائع للحصول على الرابط الحالي.',
  payment_link_used: 'تم الدفع بهذا الرابط بالفعل.',
  payment_link_closed: 'لم يعد الطلب بانتظار الدفع (مدفوع أو ملغى).',
  payment_link_amount_changed: 'تغيّر إجمالي الطلب بعد إنشاء الرابط؛ يلزم رابط جديد.',
  payment_link_not_allowed:
    'لا يمكن إنشاء روابط الدفع إلا للطلبات مسبقة الدفع (بانتظار الدفع أو مسودة) التي يزيد إجماليها على الصفر.',
  payment_link_not_found: 'لم يُعثر على رابط الدفع. تأكد من نسخ الرابط كاملًا.',
  card_payment_unavailable:
    'الدفع بالبطاقة غير مُعدّ (يتطلب الإعداد): اربط مزوّد دفع من المدفوعات ← إعدادات الدفع.',
  payment_in_progress: 'توجد محاولة دفع جارية لهذا الطلب. حاول مرة أخرى بعد بضع دقائق.',
  preauth_not_supported: 'التفويض المسبق متاح فقط مع iyzico (غير متاح لـ {{provider}}).',
  no_authorized_payment: 'لا يوجد لهذا الطلب تفويض مسبق غير محصَّل.',
  exceeds_authorization:
    'يتجاوز الإجمالي الجديد المبلغ المحجوز على البطاقة؛ لا يمكن تحصيل أكثر من المبلغ المحجوز.',
  preauth_capture_failed:
    'تعذّر تحصيل التفويض المسبق: {{detail}}. تحقّق من لوحة مزوّد الدفع، وعند الحاجة حرّر الحجز واستلم دفعة جديدة.',
  preauth_release_failed: 'تعذّر تحرير التفويض المسبق: {{detail}}. تحقّق من لوحة مزوّد الدفع.',
  release_authorization_first:
    'يوجد مبلغ محجوز على البطاقة لهذا الطلب: استخدم «تحرير التفويض المسبق» لإلغائه.',
  order_line_unknown: 'هذا المنتج ليس جزءًا من الطلب.',
  quantity_exceeds_remaining: 'لا يمكن أن تتجاوز الكمية الكمية التي لا تزال بانتظار الشحن.',
  nothing_to_ship: 'لم يتبقَّ شيء للشحن؛ تم شحن جميع منتجات الطلب.',
  partial_shipment_not_for_cod:
    'لا يمكن تقسيم طلب الدفع عند الاستلام: يجب أن يكون المبلغ المطلوب تحصيله في طرد واحد. اشحن جميع المنتجات معًا.',
  order_partially_shipped:
    'تم شحن جزء من الطلب. اشحن المنتجات المتبقية باستخدام «شحن»، ولإلغاء الطلب ألغِ شحناته أولًا.',
  exchange_not_for_withdrawal:
    'في حالة الانسحاب يُسترد ثمن المنتج؛ أما للاستبدال فاختر سببًا مثل «منتج معيب» أو «منتج خاطئ» أو «أخرى».',
  exchange_requires_delivery: 'يمكن طلب الاستبدال بعد تسليم الطلب إليك.',
  exchange_variant_invalid: 'لا يمكن استخدام هذا الخيار للاستبدال: اختر خيارًا من المنتج نفسه وبالسعر نفسه.',
  exchange_out_of_stock: 'لا يوجد مخزون كافٍ من الخيار الذي اخترته. اختر خيارًا آخر أو اطلب استرداد المبلغ.',
  not_an_exchange: 'هذا الطلب ليس طلب استبدال.',
  exchange_not_approved: 'لا يُشحن منتج الاستبدال إلا لطلب استبدال موافق عليه.',
  exchange_ship_required:
    'يُستكمل الاستبدال عبر «شحن الاستبدال»: يُخصم المنتج الجديد من المخزون ويتلقى العميل رقم التتبع.',
  partial_cancel_not_allowed:
    'الإلغاء الجزئي متاح فقط للطلب الذي شُحن جزء منه (قيد المعالجة). أما الطلب الذي لم يُشحن منه شيء فألغِه بالكامل.',
  nothing_to_cancel: 'لا يوجد ما يُلغى؛ لا توجد منتجات بانتظار الشحن.',
  address_city_unknown: 'المحافظة غير موجودة في القائمة؛ اخترها من القائمة.',
  address_district_unknown: 'هذه المنطقة لا تتبع المحافظة المحددة؛ اخترها من القائمة.',
  neighbourhood_unknown: 'هذا الحي ليس في المنطقة المختارة؛ اختر من القائمة.',
  point_outside_turkey: 'يبدو أن الموقع خارج تركيا؛ تحقّق من خط العرض وخط الطول.',
  sales_point_location_used: 'توجد نقطة بيع لهذا الموقع بالفعل.',
  sales_point_pin_manual: 'دبوس هذه النقطة مُدخل يدويًا؛ احذفه أولًا لتحديد الموقع من العنوان.',
  needs_finder_id_format: 'استخدم في المعرّف حروفًا لاتينية صغيرة أو أرقامًا أو شرطات (40 حرفًا كحد أقصى).',
  needs_finder_duplicate_id: 'هذا المعرّف مستخدم بالفعل؛ يجب أن يكون لكل عنصر معرّف مختلف.',
  needs_finder_unknown_area: 'مجال الدعم في الشرط غير موجود؛ أضفه أو احذفه من الشرط.',
  needs_finder_unknown_answer: 'السؤال أو الخيار في الشرط غير موجود؛ اختر من القائمة.',
  needs_finder_product_missing: 'المنتج غير موجود (ربما حُذف)؛ اختر منتجًا آخر.',
  needs_finder_promotion_missing: 'الحملة غير موجودة في هذا المتجر؛ اختر حملة تلقائية من هذا المتجر.',
  needs_finder_draft_exists: 'لهذا المتجر مسودة بالفعل. استخدم «إعادة إنشاء المسودة» لاستبدالها.',
  needs_finder_not_submitted: 'لم تُرسل المسودة للمراجعة أو تغيّرت بعد الإرسال؛ أرسلها أولًا.',
  needs_finder_no_areas: 'أضف مجال دعم واحدًا على الأقل.',
  needs_finder_no_rules: 'أضف قاعدة توصية واحدة على الأقل.',
  needs_finder_no_emergency_option:
    'حدّد خيار طوارئ واحدًا على الأقل؛ في الطوارئ يُوجَّه الزائر إلى طبيب بيطري.',
  needs_finder_pets_disabled: 'حفظ الحيوانات الأليفة متوقف في هذا المتجر.',
  needs_finder_pets_full: 'يمكنك حفظ 20 حيوانًا كحد أقصى؛ احذف واحدًا أولًا.',
  needs_finder_consent_required: 'ضع علامة في مربع الموافقة الصريحة للحفظ.',
  needs_finder_report_days: 'يمكن أن تكون المدة 7 أو 30 أو 90 يومًا.',
  location_not_found: 'الموقع لا يتبع هذا الوكيل.',
  hours_overlap: 'فترات ساعات العمل متداخلة في اليوم نفسه.',
  hours_range: 'يجب أن يكون وقت الإغلاق بعد وقت الفتح.',
  time_format: 'يجب أن يكون الوقت بالصيغة HH:MM (مثل 09:00).',
  postal_code_format: 'يجب أن يتكون الرمز البريدي من 5 أرقام (مثل 34710).',
  postal_code_city_mismatch: 'الرمز البريدي لا يتبع المحافظة المحددة: أول رقمين هما رمز المحافظة.',
  month_format: 'يجب أن يكون الشهر بصيغة YYYY-MM (مثل 2026-10).',
  archive_year_required: 'يلزم تحديد السنة لاختيار شهر من الأرشيف.',
  form_field_id: 'يمكن أن يحتوي معرّف الحقل على أحرف لاتينية صغيرة وأرقام وشرطات سفلية فقط (40 كحد أقصى).',
  form_label_required: 'أدخل تسمية للحقل.',
  form_options_required: 'تحتاج قائمة الاختيار إلى خيارين على الأقل.',
  form_options_duplicate: 'يجب أن تختلف الخيارات عن بعضها.',
  form_too_many_fields: 'يمكن أن يحتوي النموذج على 20 حقلًا كحد أقصى.',
  form_field_duplicate: 'أُضيف الحقل نفسه مرتين.',
  form_email_required: 'يحتاج نموذج التواصل إلى حقل بريد إلكتروني إلزامي حتى تتمكن من الرد.',
  form_privacy_notice_required: 'انشر إشعار الخصوصية (KVKK) أولًا لتفعيل النموذج (النصوص القانونية).',
  form_disabled: 'هذا النموذج غير متاح حاليًا.',
  form_field_required: 'هذا الحقل مطلوب.',
  form_value_invalid: 'أدخل قيمة صالحة.',
  form_value_too_long: 'النص طويل جدًا.',
  s3_endpoint_invalid: 'نقطة نهاية التخزين الكائني أو اسم الحاوية (bucket) أو المفاتيح مفقودة أو غير صالحة.',
  s3_auth_failed: 'رُفضت مفاتيح التخزين الكائني.',
  s3_bucket_missing: 'لا توجد حاوية (bucket) بهذا الاسم في التخزين الكائني.',
  s3_unreachable: 'تعذّر الوصول إلى خادم التخزين الكائني.',
  s3_verify_failed: 'تعذّر التحقق من ملف الاختبار في التخزين الكائني.',
  newsletter_unavailable: 'الاشتراك في النشرة البريدية غير متاح حاليًا.',
  newsletter_consent_required: 'ضع علامة في مربع الموافقة للاشتراك.',
  newsletter_token_invalid: 'رابط التأكيد غير صالح أو منتهي الصلاحية. يمكنك الاشتراك مجددًا من النموذج.',
  unsubscribe_token_invalid: 'الرابط غير صالح. تأكد من فتح الرابط كاملًا من البريد الإلكتروني.',
  suppression_exists: 'هذا العنوان موجود بالفعل في قائمة الحظر.',
  iys_auth_failed: 'لم يُقبل اسم المستخدم أو كلمة المرور الخاصة بـ İYS.',
  iys_invalid_settings:
    'إعدادات İYS غير مكتملة: رمز İYS ورمز العلامة التجارية واسم المستخدم وكلمة المرور مطلوبة.',
  iys_rejected: 'لم يقبل İYS السجل؛ راجع قائمة سجلات İYS للاطلاع على التفاصيل.',
  iys_unreachable: 'تعذّر الوصول إلى İYS. ستُعاد المحاولة لاحقًا.',
  segment_rules_required: 'أضف شرطًا واحدًا على الأقل.',
  segment_condition_invalid: 'الشرط غير مكتمل أو غير صالح: تحقّق من الحقل والمقارنة والقيمة.',
  segment_limit: 'يمكنك إنشاء {{max}} شريحة كحد أقصى. احذف الشرائح التي لم تعد تستخدمها.',
  segment_name_taken: 'توجد شريحة بهذا الاسم بالفعل.',
  email_provider_not_live: 'هذا المزوّد غير متصل. أدخل بياناته أولًا في التكاملات واختبر الاتصال.',
  ses_invalid_settings: 'إعدادات Amazon SES غير مكتملة.',
  ses_auth_failed: 'لم تُقبل مفاتيح الوصول إلى Amazon.',
  ses_unreachable: 'تعذّر الوصول إلى Amazon SES.',
  ses_sending_disabled: 'الإرسال معطّل في حساب Amazon SES.',
  sendgrid_invalid_settings: 'إعدادات SendGrid غير مكتملة.',
  sendgrid_auth_failed: 'لم يُقبل مفتاح SendGrid API.',
  sendgrid_missing_scope: 'مفتاح SendGrid API لا يملك صلاحية إرسال البريد.',
  sendgrid_unreachable: 'تعذّر الوصول إلى SendGrid.',
  postmark_invalid_settings: 'إعدادات Postmark غير مكتملة.',
  postmark_auth_failed: 'لم يُقبل رمز خادم Postmark.',
  postmark_unreachable: 'تعذّر الوصول إلى Postmark.',
  email_link_invalid:
    'رابط غير صالح. استخدم مسارًا داخل المتجر (/campaign) أو عنوانًا كاملًا يبدأ بـ http(s).',
  email_block_duplicate: 'أُضيفت الكتلة نفسها مرتين؛ أعد تحميل الصفحة وحاول مرة أخرى.',
  test_recipient_not_staff:
    'يمكن إرسال رسائل الاختبار فقط إلى مستخدمي لوحة التحكم في منشأتك (حتى 5 عناوين). اترك الحقل فارغًا لإرسالها إلى نفسك.',
  email_not_configured:
    'إرسال البريد الإلكتروني غير مُعدّ (يتطلب الإعداد): اربط SMTP أو مزوّد بريد إلكتروني من شاشة الاتصالات.',
  email_image_unavailable: 'لم يُعثر على الصورة أو لا يمكن استخدامها؛ ارفعها مرة أخرى.',
  email_products_source_missing: 'لم يُعثر على المنتج أو المجموعة أو الفئة المحددة؛ اختر المصدر مرة أخرى.',
  campaign_audience_empty: 'اختر شريحة واحدة على الأقل أو أضف مشتركي النشرة البريدية.',
  campaign_segment_missing: 'لم يُعثر على إحدى الشرائح المحددة (ربما حُذفت)؛ أعد تحميل القائمة.',
  campaign_template_invalid: 'اختر قالب بريد إلكتروني تابعًا لهذا المتجر.',
  campaign_subject_b_required: 'اكتب الموضوع B لاختبار A/B.',
  campaign_not_editable: 'لا يمكن تغيير إلا الحملة التي في حالة المسودة.',
  campaign_not_deletable: 'لا يمكن حذف حملة بدأ إرسالها؛ يبقى تقريرها محفوظًا.',
  campaign_not_cancellable: 'انتهى إرسال هذه الحملة أو توقّف بالفعل.',
  campaign_not_paused: 'الحملة غير متوقفة مؤقتًا.',
  campaign_schedule_invalid: 'يجب أن يكون وقت الإرسال بعد الآن وخلال 90 يومًا كحد أقصى.',
  campaign_no_recipients:
    'لا يوجد في هذا الجمهور من يمكنه استلامها (بعد التحقق من قائمة الحظر والموافقة وİYS).',
  template_review_required:
    'يحتوي القالب على ادعاءات صحية بانتظار موافقة المختص، ولا يمكن إرساله قبل الموافقة.',
  automation_email_required: 'يحتاج المسار إلى خطوة بريد إلكتروني واحدة على الأقل.',
  automation_wait_last: 'لا يمكن أن ينتهي المسار بخطوة انتظار؛ احذفها أو أضف بعدها بريدًا إلكترونيًا.',
  automation_condition_invalid: 'لا يمكن استخدام هذا الشرط في هذا المسار.',
  automation_template_required: 'اختر قالبًا لخطوة البريد الإلكتروني هذه لتفعيل المسار.',
  birthday_invalid: 'هذا الشهر لا يحتوي على هذا اليوم.',
  template_unavailable: 'القالب غير متاح (محذوف أو بانتظار موافقة المختص).',
  frequency_cap: 'تلقّى الشخص مؤخرًا رسالة تسويقية أخرى (حد التكرار).',
  stock_alerts_unavailable: 'خيار «أعلمني عند التوفر» غير مستخدم في هذا المتجر.',
  stock_alert_in_stock: 'هذا الخيار متوفر الآن؛ يمكنك إضافته إلى سلة التسوق.',
  stock_alert_not_waiting: 'لم يعد هذا الطلب قيد الانتظار (تم الإشعار أو أُغلق).',
  price_drop_store_required: 'اختر المتجر الذي تُستخدم أسعاره وروابطه في إشعارات انخفاض السعر.',
  products_unavailable: 'تعذّر عرض المنتجات في البريد الإلكتروني (غير منشورة أو بانتظار الموافقة).',
  expired: 'انتهت الصلاحية.',
  suppressed: 'العنوان في قائمة الحظر.',
  panel: 'أُلغي من لوحة التحكم.',
  rejected: 'رفض مزوّد البريد الإلكتروني الرسالة.',
  sms_template_in_use: 'يُستخدم قالب SMS هذا في حملة معلّقة؛ احذف الحملة أو اختر قالبًا آخر أولًا.',
  sms_not_configured:
    'لا يوجد مزوّد SMS متصل (يتطلب الإعداد): اربط Netgsm أو İleti Merkezi أو Verimor في التكاملات، ثم اختره في إعدادات SMS وWhatsApp.',
  sms_mersis_required: 'تتطلب الرسائل النصية التجارية رقم MERSİS: أدخله في بيانات المنشأة.',
  sms_opt_out_required: 'تتطلب الرسائل النصية التجارية نصًا لإلغاء الاشتراك: أدخله في إعدادات SMS وWhatsApp.',
  sms_provider_not_connected: 'لا يوجد اتصال مباشر لمزوّد SMS هذا: اربطه واختبره أولًا في التكاملات.',
  sms_template_required: 'اختر قالب SMS.',
  whatsapp_not_configured: 'WhatsApp Business غير متصل (يتطلب الإعداد): اربطه من التكاملات.',
  whatsapp_unreachable: 'تعذّر الوصول إلى WhatsApp (Meta). حاول مرة أخرى لاحقًا.',
  whatsapp_auth_failed: 'رُفض رمز الوصول إلى WhatsApp: جدّده في التكاملات.',
  whatsapp_template_not_approved: 'لم يُعثر على قالب WhatsApp هذا لدى Meta أو أنه غير معتمد.',
  whatsapp_template_health_claim: 'يحتوي قالب WhatsApp أو متغيراته على ادعاء صحي؛ لا يمكن إرساله بهذا النص.',
  whatsapp_template_required: 'اختر قالب WhatsApp أو اكتب اسمه ولغته.',
  whatsapp_params_mismatch: 'يجب أن يطابق عدد المتغيرات ما في القالب.',
  firebase_not_configured: 'Firebase غير متصل (يتطلب الإعداد): اربط حساب خدمة Firebase في التكاملات.',
  firebase_auth_failed: 'رُفض حساب خدمة Firebase: جدّده في التكاملات.',
  no_devices: 'لا توجد أجهزة مسجّلة لهذا الحساب؛ فعّل الإشعارات أولًا في تطبيق الإدارة على Android.',
  quiet_hours_invalid: 'يجب أن تبدأ ساعات الهدوء وتنتهي في وقتين مختلفين.',
  web_push_key_required: 'أنشئ مفتاح الإشعارات أولًا.',
  web_push_key_exists: 'يوجد مفتاح بالفعل؛ استخدم «استبدال المفتاح» لتجديده (تنتهي الاشتراكات الحالية).',
  web_push_unavailable: 'إشعارات المتصفح غير متاحة لهذا المتجر حاليًا.',
  web_push_not_configured: 'إشعارات واجهة المتجر غير مُعدّة (يتطلب الإعداد): أنشئ المفتاح وفعّل الإعداد.',
  push_contact_required: 'يلزم عنوان تواصل لتفعيل الإشعارات.',
  push_contact_invalid: 'يجب أن يبدأ عنوان التواصل بـ mailto: أو https://.',
  push_endpoint_invalid: 'عنوان الإشعارات في المتصفح غير مدعوم.',
  push_keys_invalid: 'مفاتيح الإشعارات في المتصفح غير صالحة.',
  push_url_invalid: 'اكتب مسارًا داخل المتجر يبدأ بـ / (مثل /kategori/kedi).',
  promotion_tiers_invalid: 'يجب أن تختلف عتبات المستويات، وتبدأ مستويات الكمية من 1.',
  promotion_pay_invalid: 'يجب أن تكون قيمة «ادفع» أقل من «اشترِ» (مثل اشترِ 3 وادفع ثمن 2).',
  promotion_currency_required: 'اختر عملة للعرض الترويجي الذي يتضمن مبالغ.',
  promotion_not_editable: 'لا يمكن تغيير عرض ترويجي منشور؛ أوقفه مؤقتًا أولًا.',
  promotion_not_deletable: 'يُحتفظ بالعرض الترويجي الذي نُشر (لسجل الأسعار والتقارير)؛ يمكنك إيقافه مؤقتًا.',
  promotion_status_invalid: 'العرض الترويجي ليس في حالة تسمح بهذا الإجراء.',
  promotion_ended: 'انقضى تاريخ انتهاء العرض الترويجي؛ حدّث التواريخ.',
  coupon_not_combinable: 'لا يمكن الجمع بين رمز الخصم هذا والعرض الموجود في سلة التسوق.',
  order_promotions_locked: 'لا يمكن تغيير منتجات طلب يتضمن عروضًا تلقائية؛ ألغِ الطلب وأنشئ طلبًا جديدًا.',
  gift_card_balance_negative: 'لا يمكن أن ينخفض الرصيد عن الصفر.',
  store_credit_insufficient: 'رصيد المتجر غير كافٍ.',
  gift_card_not_found: 'لم يُعثر على بطاقة الهدية أو لا يمكن استخدامها. تحقّق من الرمز.',
  gift_card_expired: 'انتهت صلاحية بطاقة الهدية هذه.',
  gift_card_currency: 'بطاقة الهدية هذه ليست بعملة هذا المتجر.',
  gift_card_empty: 'لم يتبقَّ رصيد في بطاقة الهدية هذه.',
  store_credit_login_required: 'سجّل الدخول لاستخدام رصيد المتجر.',
  gift_card_balance_changed: 'تغيّر رصيد بطاقة الهدية. تحقّق من المبلغ المستحق وحاول مرة أخرى.',
  store_credit_balance_changed: 'تغيّر رصيدك في المتجر. تحقّق من المبلغ المستحق وحاول مرة أخرى.',
  gift_card_missing: 'لم يُعثر على سجل بطاقة الهدية لهذه الدفعة.',
  store_credit_no_customer: 'لا يمكن منح رصيد المتجر إلا لعميل مسجّل (هذا طلب زائر).',
  date_in_past: 'يجب أن يكون التاريخ في المستقبل.',
  not_zero: 'لا يمكن أن يكون المبلغ صفرًا.',
  refund_order_not_paid:
    'لم يُدفع الطلب بالكامل. ألغِ الطلب بدلًا من استرداد المبلغ؛ يُستعاد رصيد بطاقة الهدية/رصيد المتجر تلقائيًا.',
  store_credit_not_for_withdrawal:
    'يجب إعادة مبلغ الاسترداد في حالة الانسحاب إلى وسيلة الدفع الخاصة بالعميل، ولا يمكن منحه كرصيد للمتجر.',
  store_credit_consent_required: 'يلزم الحصول على موافقة صريحة من العميل لاسترداد المبلغ كرصيد للمتجر.',
  loyalty_points_insufficient: 'النقاط غير كافية (المتاح: {{points}} نقطة).',
  loyalty_points_limit: 'سيتجاوز رصيد النقاط الحد الأقصى.',
  loyalty_tier_name_duplicate: 'اسم المستوى هذا مستخدم في مستوى آخر.',
  loyalty_tier_spend_duplicate: 'لا يمكن أن يكون لمستويين حد الإنفاق نفسه.',
  loyalty_nothing_to_offer: 'لتفعيل البرنامج حدّد معدل كسب النقاط أو مستوى واحدًا على الأقل.',
  loyalty_login_required: 'سجّل الدخول لاستخدام النقاط.',
  loyalty_unavailable: 'لا يمكن استخدام نقاط الولاء في هذا الطلب.',
  loyalty_min_redeem: 'ليس لديك نقاط كافية لاستخدامها بعد.',
  loyalty_points_changed: 'تغيّر رصيد نقاطك؛ تحقّق من المبلغ وأكّد مرة أخرى.',
  order_loyalty_locked: 'لا يمكن تغيير منتجات طلب يتضمن خصم مستوى الولاء؛ ألغِ الطلب وأنشئه من جديد.',
  referral_self: 'لا يمكنك استخدام رمز الدعوة الخاص بك.',
  referral_not_first_order: 'لا يمكن استخدام رمز الدعوة إلا في الطلب الأول.',
  referral_percentage_max: 'يمكن أن يبلغ خصم الإحالة 50% كحد أقصى.',
  referral_unavailable: 'برنامج الإحالة غير متاح حاليًا.',
  referral_code_failed: 'تعذّر إنشاء رمز الدعوة؛ يرجى المحاولة مرة أخرى.',
  affiliate_source_format:
    'يجب أن يتكون المصدر من أحرف لاتينية صغيرة أو أرقام أو شرطات أو شرطات سفلية (2–40 حرفًا).',
  affiliate_discount_taken: 'رمز الخصم هذا مرتبط بشريك آخر.',
  affiliate_source_taken: 'هذا المصدر مستخدم لدى شريك آخر.',
  commission_not_approved: 'لا يمكن وضع علامة «مدفوعة» إلا على العمولات المعتمدة.',
  ticket_number_failed: 'تعذّر تعيين رقم التذكرة؛ يرجى المحاولة مرة أخرى.',
  ticket_agent_invalid: 'لا يمكن إسناد التذاكر إلا إلى موظف نشط لديه صلاحية الرد على طلبات الدعم.',
  ticket_closed: 'هذه التذكرة مغلقة ولا تُقبل الردود عليها. يمكنك فتح تذكرة جديدة.',
  ticket_email_required: 'لا تحتوي الرسالة على بريد إلكتروني؛ لا يمكن تحويلها إلى تذكرة.',
  ticket_already_created: 'تم تحويل هذه الرسالة بالفعل إلى التذكرة رقم #{{number}}.',
  ticket_order_not_found: 'لم يُعثر على هذا الطلب في حسابك.',
  ticket_not_resolved: 'يمكنك تقييم التذكرة بعد حلّها.',
  ticket_already_rated: 'لقد قيّمت هذه التذكرة بالفعل.',
  macro_title_taken: 'يوجد رد جاهز بهذا الاسم بالفعل.',
  support_report_days: 'يمكن أن تكون الفترة 7 أو 30 أو 90 أو 365 يومًا.',
  chat_privacy_notice_required: 'انشر إشعار الخصوصية (KVKK) قبل تفعيل الدردشة المباشرة.',
  chat_unavailable: 'الدعم المباشر غير متاح حاليًا.',
  chat_offline: 'لا يوجد موظف متصل حاليًا؛ يمكنك ترك رسالة.',
  chat_closed: 'انتهت هذه الدردشة. يمكنك بدء دردشة جديدة.',
  chat_taken: 'تولّى موظف آخر هذه الدردشة.',
  chat_ticket_exists: 'تم تحويل هذه الدردشة بالفعل إلى تذكرة دعم.',
  chat_empty: 'لا تحتوي الدردشة على رسالة من الزائر؛ لا يمكن تحويلها.',
  ads_utm_source_format:
    'يجب أن يتكون المصدر من 2 إلى 40 حرفًا: أحرف لاتينية صغيرة وأرقام ونقطة وشرطة وشرطة سفلية فقط.',
  ads_currency_unsupported: 'هذه العملة غير مدعومة.',
  ads_account_exists: 'يوجد بالفعل حساب إعلاني بهذا المعرّف على هذه المنصة.',
  ads_import_columns:
    'لم يُعثر على الأعمدة المطلوبة في الملف: {{columns}}. أعمدة التاريخ والحملة والإنفاق مطلوبة.',
  ads_no_live_source: 'لا يوجد اتصال إعلاني مباشر. أعدّ Meta أو TikTok من صفحة «الاتصالات».',
  ads_report_days: 'يمكن أن تكون الفترة 7 أو 30 أو 90 يومًا.',
  ads_change_value_required: 'أدخل مبلغًا لتغيير الميزانية أو اختر حالة لتغيير العرض.',
  ads_change_not_pending: 'لم يعد هذا الطلب قيد الانتظار.',
  ads_change_not_approved: 'لا يمكن وضع علامة «مُطبَّق» إلا على طلب تمت الموافقة عليه.',
  ads_change_self_approval: 'لا يمكنك الموافقة على طلبك بنفسك؛ يجب أن يوافق عليه مستخدم مفوَّض آخر.',
  google_ads_conversion_action_format:
    'يجب أن يكون إجراء التحويل بالصيغة customers/1234567890/conversionActions/123.',
  google_ads_cloud_project_not_approved:
    'لا يستطيع مشروع Google Cloud الخاص بك الوصول عبر Google Ads API إلا إلى الحسابات التجريبية (وصول Test). للحساب الإعلاني الحقيقي، قدّم طلب الوصول Explorer في Google Cloud: Google Cloud Console ← Google Ads API ← نظرة عامة (مشروع عميل OAuth المستخدم في اتصال Google).',
  google_ads_user_permission_denied:
    'لا يستطيع حساب Google المرتبط الوصول إلى حساب Google Ads هذا. إذا كنت تصل إليه عبر حساب إداري (MCC)، فأدخل معرّف MCC في التكاملات ← Google Ads؛ وإذا أدخلته، فتحقق من أنه يدير هذا الحساب.',
  google_ads_customer_not_enabled: 'حساب Google Ads هذا غير مفعّل بعد أو تم إغلاقه.',
  google_ads_authorization_error:
    'رفض Google Ads التفويض. إذا رُفع مستوى وصول مشروع Cloud بعد 9 سبتمبر 2026، فقد تكون هذه مشكلة معروفة أبلغت عنها Google: أنشئ مشروع Google Cloud جديدًا وقدّم طلب الوصول Explorer.',
  google_ads_api_not_enabled:
    'واجهة Google Ads API غير مفعّلة في مشروع Google Cloud أو لم تُقبل شروط الخدمة. فعّل Google Ads API في Google Cloud Console.',
  google_ads_quota_exceeded:
    'تم بلوغ حد طلبات Google Ads API. في وصول Explorer يوجد حد يومي للعمليات على الحسابات الحقيقية؛ تُعاد محاولة العملية تلقائيًا لاحقًا.',
  google_ads_access_prohibited:
    'الوصول إلى Google Ads API محظور لمشروع Google Cloud هذا. تحقّق من مستوى وصول Google Ads API في Google Cloud Console.',
  google_ads_action_not_permitted:
    'لا يُسمح لحساب Google المرتبط بتنفيذ هذه العملية في حساب Google Ads هذا (قد يكون وصوله للقراءة فقط). اربط حسابًا بوصول قياسي أو إداري.',
  google_ads_account_suspended:
    'حساب Google Ads معلّق؛ لا يمكن إجراء تغييرات. تحقّق من حالة الحساب في Google Ads.',
  google_ads_not_allowlisted: 'ميزة Google Ads هذه غير متاحة لحسابك (تتطلب إدراجًا من Google).',
  google_ads_policy_violation:
    'رُفض بموجب سياسة إعلانات Google. عدّل النص أو المنتج؛ لا تُستخدم في المنتجات الصحية عبارات مثل «يعالج» أو «يقي» أو «يشفي». التفاصيل في حالة السياسة للحملة.',
  google_ads_budget_too_low: 'الميزانية اليومية منخفضة جدًا لـ Google Ads. أدخل ميزانية يومية أعلى.',
  google_ads_budget_too_high: 'الميزانية اليومية تتجاوز الحد الأقصى في Google Ads.',
  google_ads_budget_currency: 'مبلغ الميزانية لا يطابق عملة الحساب أو أصغر وحدة فيها.',
  google_ads_budget_invalid:
    'رفض Google Ads إعداد الميزانية. تحقّق من أن الميزانية غير مستخدمة في حملة أخرى ولم تُحذف.',
  google_ads_duplicate_name: 'توجد حملة أو ميزانية بهذا الاسم. أدخل اسمًا مختلفًا.',
  google_ads_bid_out_of_range: 'قيمة العرض خارج حدود Google Ads.',
  google_ads_bidding_invalid: 'لا يمكن استخدام استراتيجية عروض الأسعار المختارة مع نوع الحملة أو الميزانية.',
  google_ads_temporary_error: 'أعاد Google Ads خطأً مؤقتًا. تُعاد محاولة العملية تلقائيًا بعد قليل.',
  google_ads_resource_not_found:
    'لم يُعثر على المورد في Google Ads (ربما حُذف من Google Ads). زامن ثم أعد المحاولة.',
  google_ads_value_out_of_range: 'القيمة خارج حدود Google Ads.',
  google_ads_resource_limit: 'بلغ حساب Google Ads حدًّا للموارد (مثل عدد الحملات أو الأصول).',
  google_ads_request_rejected: 'رفض Google Ads الطلب. راجع سجل اتصال Google للتفاصيل.',
  google_ads_conversion_action_required: 'أدخل إجراء التحويل لتفعيل رفع التحويلات.',
  google_ads_not_linked:
    'لا يوجد حساب Google Ads مرتبط بهذا المتجر. اختر حساب Google Ads للمتجر في صفحة اتصالات Google.',
  google_ads_merchant_link_missing:
    'حساب Merchant Center غير مرتبط بحساب Google Ads. اطلب الربط من Merchant Center ووافق عليه في Google Ads.',
  google_ads_purchase_conversion_missing:
    'لا يوجد في حساب Google Ads تحويل «شراء» أساسي ونشط. تعمل الحملات على تحويلات الشراء؛ أعد تتبع التحويلات أولًا.',
  google_ads_campaign_removed: 'أُزيلت الحملة ولم يعد بالإمكان تغييرها.',
  google_ads_not_draft: 'يمكن تعديل أو حذف مسودة الحملة فقط.',
  google_ads_operation_open: 'توجد عملية معلّقة لهذه الحملة. انتظر نتيجتها أو ألغها أولًا.',
  google_ads_already_created: 'أُنشئت الحملة بالفعل في Google Ads.',
  google_ads_not_created: 'لم تُنشأ الحملة في Google Ads بعد. أرسل المسودة للموافقة أولًا.',
  google_ads_already_enabled: 'الحملة منشورة بالفعل.',
  google_ads_not_enabled: 'الحملة غير منشورة.',
  google_ads_bidding_not_for_kind: 'لا يمكن استخدام استراتيجية العروض هذه مع نوع الحملة هذا.',
  google_ads_target_not_for_bidding: 'لا يمكن استخدام هذا الهدف مع استراتيجية العروض المختارة.',
  google_ads_end_before_start: 'لا يمكن أن يسبق تاريخ الانتهاء تاريخ البدء.',
  google_ads_no_change: 'القيمة نفسها بالفعل؛ لا يوجد تغيير.',
  google_ads_operation_not_pending: 'لم تعد هذه العملية بانتظار الموافقة.',
  google_ads_self_approval: 'لا يمكنك الموافقة على طلبك؛ يجب أن يوافق عليه مسؤول موافقة آخر أو مالك النشاط.',
  google_ads_monthly_cap_missing:
    'لم يُحدَّد سقف شهري لميزانية الإعلانات. لا يمكن الموافقة على العمليات التي تسبب إنفاقًا قبل تحديد السقف.',
  google_ads_monthly_cap_exceeded:
    'الحد الأعلى الشهري المقدّر يتجاوز سقف ميزانية الإعلانات الشهري. خفّض الميزانية أو ارفع السقف.',
  google_ads_no_products: 'لا توجد منتجات في الحملة. أضف منتجات قبل النشر.',
  google_ads_goal_not_applied: 'لم يُطبَّق هدف تحويل «الشراء» للحملة بعد. أعد المحاولة بعد بضع دقائق.',
  google_ads_operation_not_open: 'لا يمكن إلغاء هذه العملية: قيد التطبيق أو اكتملت.',
  google_ads_no_drift: 'لا يوجد اختلاف عن Google Ads.',
  google_ads_recommendation_invalid: 'توصية Google غير صالحة.',
  google_ads_country_unsupported: 'هذه الدولة ليست في قائمة الاستهداف.',
  google_ads_language_unsupported: 'هذه اللغة ليست في قائمة الاستهداف.',
  google_ads_daily_limit: 'بلغ حد عمليات Google Ads API لهذا اليوم؛ ستُطبَّق العملية صباح الغد.',
  google_ads_apply_interrupted:
    'انقطع التطبيق. تحقّق مما إذا كانت الحملة موجودة في Google Ads؛ وإن لم تكن، فاطلبها مجددًا.',
  google_ads_verify_mismatch:
    'أُرسل التغيير إلى Google Ads، لكن القيمة المقروءة تختلف عن المتوقعة. اطّلع على الفرق في صفحة الحملة.',
  google_ads_invalid_status_change:
    'لا يسمح Google Ads بتغيير الحالة هذا (مثلًا: لا يمكن إعادة فتح حملة مُزالة).',
  google_ads_date_in_past: 'لا يمكن اختيار تاريخ في الماضي.',
  google_ads_start_date_locked: 'لا يمكن تغيير تاريخ بدء حملة بدأت بالفعل.',
  google_ads_recommendation_stale: 'لم تعد توصية Google هذه صالحة (طُبِّقت أو أُغلقت أو حُدِّثت).',
  google_ads_basic_access_required:
    'تتطلب اقتراحات الكلمات المفتاحية وصول Basic إلى Google Ads API. يعطّل Google خدمات التخطيط مع وصول Explorer؛ احصل على موافقة Basic من Google ثم اضبط مستوى الوصول على «Basic» في إعدادات Google Ads.',
  google_ads_ad_rejected:
    'رفض Google Ads نص الإعلان (حد الأحرف أو عدد العناوين/الأوصاف أو عنوان URL النهائي). عدّل النص واطلب مجددًا.',
  google_ads_keyword_rejected:
    'رفض Google Ads كلمة مفتاحية (طويلة جدًا أو كلمات كثيرة أو رموز غير صالحة). عدّل القائمة واطلب مجددًا.',
  google_ads_final_url_invalid: 'يجب أن يكون عنوان URL النهائي عنوانًا صالحًا يبدأ بـ https://.',
  google_ads_final_url_not_store:
    'يجب أن يكون عنوان URL النهائي على نطاق المتجر نفسه (مثل صفحة منتج أو فئة).',
  google_ads_search_only: 'يُستخدم نص الإعلان والكلمات المفتاحية في حملات البحث فقط.',
  google_ads_search_no_products: 'لا تُضاف منتجات إلى حملة البحث؛ فهي تعمل بنص الإعلان والكلمات المفتاحية.',
  google_ads_keywords_min: 'أضف كلمة مفتاحية واحدة على الأقل.',
  google_ads_keywords_max: 'عدد الكلمات المفتاحية يتجاوز الحد.',
  google_ads_not_search: 'هذا الإجراء متاح لحملات البحث فقط.',
  google_ads_no_keywords: 'لا توجد كلمات مفتاحية في الحملة. أضف كلمات مفتاحية قبل التفعيل.',
  google_ads_source_not_listed: 'المنتج أو الفئة المحددة غير منشورة في واجهة هذا المتجر.',
  google_ads_source_not_reviewed:
    'المحتوى الصحي لهذا المنتج غير معتمد من الطبيب البيطري، لذلك لا تُنشأ مسودة إعلان. أرسل نص المنتج للمراجعة أولًا.',
  google_ads_ideas_seed_required: 'أدخل كلمة واحدة على الأقل أو صفحة هبوط للحصول على اقتراحات.',
  google_ads_text_review_not_pending: 'نص الإعلان هذا لا ينتظر المراجعة.',
  google_ads_headline_too_long: 'يمكن أن يتكون العنوان من 30 حرفًا كحد أقصى.',
  google_ads_description_too_long: 'يمكن أن يتكون الوصف من 90 حرفًا كحد أقصى.',
  google_ads_headlines_min: 'أدخل 3 عناوين على الأقل.',
  google_ads_headlines_max: 'يمكن إضافة 15 عنوانًا كحد أقصى.',
  google_ads_descriptions_min: 'أدخل وصفين على الأقل.',
  google_ads_descriptions_max: 'يمكن إضافة 4 أوصاف كحد أقصى.',
  google_ads_path_too_long: 'يمكن أن يتكون جزء المسار المعروض من 15 حرفًا كحد أقصى.',
  google_ads_path_invalid: 'لا يمكن أن يحتوي المسار المعروض إلا على أحرف وأرقام وشرطات.',
  google_ads_path2_without_path1: 'أدخل جزء المسار الأول قبل الثاني.',
  google_ads_text_duplicate: 'لا يمكن استخدام النص نفسه مرتين.',
  google_ads_too_many_pins: 'عناوين كثيرة مثبّتة: اترك عنوانين على الأقل دون تثبيت ليتمكن Google من التنويع.',
  google_ads_keyword_too_long: 'يمكن أن تتكون الكلمة المفتاحية من 80 حرفًا كحد أقصى.',
  google_ads_keyword_too_many_words: 'يمكن أن تتكون الكلمة المفتاحية من 10 كلمات كحد أقصى.',
  google_ads_keyword_invalid_chars: 'تحتوي الكلمة المفتاحية على رمز لا يقبله Google (مثل ! @ % , * ?).',
  google_ads_keyword_duplicate: 'هذه الكلمة المفتاحية موجودة بالفعل في القائمة بنوع المطابقة نفسه.',
  google_not_linked: 'لا يوجد مورد Google مرتبط بهذا المتجر. اختر موردًا من صفحة اتصالات Google.',
  ga4_report_days: 'يمكن أن تكون الفترة 7 أو 28 أو 90 يومًا.',
  retention_confirm_required: 'لتفعيل الإتلاف التلقائي، أكّد أن السجلات المنتهية مدتها ستُحذف نهائيًا.',
  retention_days_range: 'يجب أن تكون المدة ضمن النطاق المسموح به لنوع البيانات هذا.',
  retention_log_days: 'يمكن أن تكون الفترة 30 أو 90 أو 365 أو 1095 يومًا.',
  merchant_performance_days: 'يمكن أن تكون الفترة 7 أو 28 أو 90 يومًا.',
  custom_event_name:
    'يجب أن يبدأ اسم الحدث بحرف صغير؛ ويُسمح فقط بالأحرف a–z والأرقام والشرطة السفلية (3–40 حرفًا).',
  custom_event_reserved: 'هذا الاسم محجوز أو مستخدم لحدث قياسي؛ اختر اسمًا آخر.',
  custom_event_path:
    'يجب أن يبدأ مسار الصفحة بـ / (مثل /campaign/october)؛ أضف * في النهاية لمطابقة كل المسارات التي تبدأ به.',
  custom_event_path_required: 'أدخل مسار الصفحة لحدث مشاهدة الصفحة.',
  custom_event_destinations: 'اختر خدمة قياس واحدة على الأقل.',
  custom_event_duplicate: 'الحدث نفسه معرَّف مرتين.',
  storage_permission_denied:
    'تعذّر حفظ الملف: لا توجد صلاحية كتابة على مساحة تخزين الملفات في الخادم. أبلغ مسؤول النظام (رمز الخطأ {{requestId}}).',
  storage_disk_full: 'تعذّر حفظ الملف: قرص الخادم ممتلئ. أبلغ مسؤول النظام (رمز الخطأ {{requestId}}).',
  storage_read_only:
    'تعذّر حفظ الملف: مساحة تخزين الملفات في الخادم مركّبة للقراءة فقط. أبلغ مسؤول النظام (رمز الخطأ {{requestId}}).',
  storage_remote_failed:
    'تعذّر حفظ الملف: فشلت الكتابة إلى مخزن الكائنات المتصل (S3/R2). اختبر الاتصال من التكاملات → تخزين الكائنات (رمز الخطأ {{requestId}}).',
  storage_write_failed:
    'تعذّر حفظ الملف: فشلت الكتابة إلى مساحة تخزين الملفات. أبلغ مسؤول النظام (رمز الخطأ {{requestId}}).',
  live_sandbox_skip_owner_only:
    'لا يمكن إلا لمالك النشاط الموافقة على الانتقال إلى البيئة المباشرة دون دفعة تجريبية.',
  review_not_purchased: 'يمكنك تقييم هذا المنتج فقط بعد شرائه من هذا المتجر واستلامه.',
  review_already_submitted: 'لقد قيّمت هذا المنتج من قبل.',
  review_too_short: 'يجب ألا يقل التقييم عن 20 حرفًا.',
  review_rating_required: 'اختر تقييمًا من 1 إلى 5.',
  pdf_active_content:
    'يحتوي ملف PDF هذا على محتوى نشط (JavaScript أو ملفات مضمّنة أو تشغيل برامج) ولا يمكن نشره. أعد حفظه باستخدام «الطباعة إلى PDF» ثم ارفعه مرة أخرى.',
  video_url_invalid: 'لم يتم التعرّف على عنوان الفيديو. الصق عنوان فيديو من YouTube أو Vimeo.',
  video_duplicate: 'هذا الفيديو مضاف بالفعل.',
  document_file_invalid: 'ملف المستند غير موجود أو ليس بصيغة PDF؛ ارفعه مرة أخرى.',
  document_duplicate: 'هذا المستند مضاف بالفعل.',
  complementary_self: 'لا يمكن أن يكون المنتج مكمّلًا لنفسه.',
  password_too_short: 'يجب ألا تقل كلمة المرور عن 12 حرفًا.',
  password_too_long: 'كلمة المرور طويلة جدًا.',
  password_too_common:
    'كلمة المرور هذه شائعة جدًا أو سهلة التخمين (تظهر في قوائم كلمات المرور المسرّبة أو تحتوي على اسمك)؛ اختر كلمة مرور أطول من عدة كلمات وأرقام.',
  password_contains_email: 'يجب ألا تحتوي كلمة المرور على بريدك الإلكتروني.',
  required: 'هذا الحقل مطلوب.',
  in_past: 'لا يمكن أن يكون التاريخ في الماضي.',
  import_already_applied: 'تم تطبيق هذا الاستيراد بالفعل.',
  import_preview_expired: 'انتهت صلاحية المعاينة (ساعة واحدة). ارفع الملف مرة أخرى.',
  import_file_missing: 'اختر ملفًا.',
  import_file_too_large: 'الملف كبير جدًا (الحد الأقصى {{maxMb}} ميغابايت).',
  import_file_unreadable: 'تعذّرت قراءة الملف. ارفع ملف CSV أو Excel (.xlsx).',
  import_xls_unsupported: 'صيغة Excel القديمة (.xls) غير مدعومة. احفظ الملف بصيغة .xlsx أو CSV.',
  import_file_empty: 'لا يحتوي الملف على بيانات (يجب أن يكون الصف الأول صف العناوين).',
  import_too_many_rows: 'الحد الأقصى لعدد الصفوف في الملف هو {{max}}؛ قسّم الملف.',
  column_missing: 'عمود مطلوب مفقود: {{column}}',
  dealer_key_column_missing: 'يجب وجود أحد العمودين «رمز الموزّع» أو «الرقم الضريبي» على الأقل (للمطابقة).',
  masked_value:
    'لا يمكن استيراد القيم المقنّعة (التي تحتوي على ***). صدّر الملف بصلاحية عرض البيانات الشخصية دون إخفاء، أو اترك الخلية فارغة.',
  dealer_key_required: 'لا يحتوي هذا الصف على رمز موزّع أو رقم ضريبي.',
  dealer_conflict: 'يشير رمز الموزّع والرقم الضريبي إلى موزّعَين مختلفَين.',
  dealer_group_required: 'يحتاج الموزّع المعتمد إلى مجموعة موزّعين (تُؤخذ أسعار الموزّعين من هذه المجموعة).',
  dealer_group_unknown: 'لا توجد مجموعة موزّعين بهذا الاسم.',
  dealer_code_taken: 'رمز الموزّع هذا مستخدم بالفعل لدى شركة أخرى.',
  tax_number_registered: 'توجد بالفعل شركة مسجّلة بهذا الرقم الضريبي.',
  tax_number_invalid: 'الرقم الضريبي (10 أرقام) أو رقم الهوية الوطنية (11 رقمًا) غير صالح.',
  tax_number_format: 'صيغة الرقم الضريبي غير صالحة.',
  phone_format: 'رقم الهاتف غير صالح (مثال: +90 532 123 45 67).',
  email_format: 'البريد الإلكتروني غير صالح.',
  invalid_status_transition: 'تغيير الحالة هذا غير مسموح به.',
  application_already_decided: 'تم البت في هذا الطلب بالفعل.',
  application_pending: 'لديك بالفعل طلب قيد المراجعة.',
  already_dealer: 'حسابك مرتبط بالفعل بشركة موزّعة.',
  company_exists:
    'لدينا بالفعل موزّع بهذا الرقم الضريبي. اطلب من المسؤول المفوّض في شركتك إضافتك، أو تواصل معنا.',
  note_required: 'يجب كتابة ملاحظة.',
  payment_note_required: 'صِف كيف تم استلام الدفعة (مثل مرجع التحويل البنكي أو الحساب الآجل).',
  consent_proof_required: 'أدخل مرجع مستند أو نص للموافقة (مثل رقم النموذج الموقّع).',
  customer_disabled: 'حساب العميل معطّل.',
  customer_anonymized:
    'تم إخفاء هوية البيانات الشخصية لهذا العميل بعد طلب حذف؛ لا يمكن تعديل الحساب أو إعادة فتحه.',
  privacy_export_limit: 'يمكنك تنزيل بياناتك 5 مرات كحد أقصى خلال 24 ساعة. يرجى المحاولة لاحقًا.',
  privacy_request_open: 'لديك بالفعل طلب حذف مفتوح؛ سيتم إشعارك بالبريد الإلكتروني عند البت فيه.',
  privacy_not_erasure: 'لا يتم إخفاء الهوية إلا في طلبات الحذف.',
  privacy_request_closed: 'تم البت في هذا الطلب بالفعل.',
  privacy_already_anonymized: 'تم إخفاء هوية بيانات هذا الشخص بالفعل.',
  privacy_store_credit_balance:
    'لدى العميل رصيد متجر ({{balances}}). ادفعه له أو صفّره بموافقة العميل (العملاء → رصيد المتجر) قبل الحذف.',
  privacy_subject_not_found:
    'لا يوجد حساب عميل أو طلب شراء بهذا البريد الإلكتروني؛ لا توجد بيانات لإخفاء هويتها. أغلق طلب صاحب البيانات بملاحظة.',
  privacy_open_orders:
    'عدد الطلبات غير المغلقة: {{count}} ({{numbers}}). يمكن إخفاء الهوية بعد تسليمها وإغلاقها أو إلغائها.',
  privacy_open_returns: 'عدد طلبات الإرجاع المفتوحة: {{count}}؛ أنهِ معالجتها أولًا.',
  privacy_erasure_not_done:
    'لا يُغلق طلب الحذف إلا بإخفاء الهوية. إذا تعذّر الحذف لأسباب قانونية، فارفض الطلب مع ذكر السبب.',
  privacy_confirm_mismatch: 'البريد الإلكتروني المُدخل لا يطابق البريد الإلكتروني لمقدّم الطلب.',
  date_in_future: 'لا يمكن أن يكون التاريخ في المستقبل.',
  domain_invalid: 'أدخل نطاقًا صالحًا (مثل example.com).',
  dkim_selector_invalid:
    'يمكن أن يحتوي محدِّد DKIM على الأحرف والأرقام والنقاط والشرطات والشرطات السفلية فقط.',
  date_too_old: 'لا يمكن أن يكون التاريخ أقدم من سنة.',
  email_registered: 'يوجد حساب بهذا البريد الإلكتروني بالفعل. سجّل الدخول أو أعد تعيين كلمة المرور.',
  account_activation_required:
    'أنشأ المتجر حسابك لهذا البريد الإلكتروني. استخدم «نسيت كلمة المرور» لتعيين كلمة المرور.',
  password_incorrect: 'كلمة المرور الحالية غير صحيحة.',
  address_limit: 'الحد الأقصى لعدد العناوين التي يمكنك حفظها هو {{max}}.',
  file_invalid: 'المستند غير موجود؛ ارفعه مرة أخرى.',
  option_names_mismatch: 'أسماء الخيارات في الملف تختلف عن الخيارات الحالية للمنتج.',
  title_required_for_new:
    'يحتاج المنتج الجديد إلى «Ürün Adı» (اسم المنتج)؛ رمز SKU هذا غير موجود في النظام. يجب أن تستخدم ملفات التحديث رموز SKU موجودة.',
  wrong_file_products:
    'يبدو هذا الملف قائمة منتجات. ارفع المنتجات من الكتالوج → الاستيراد / التصدير → «المنتجات».',
  wrong_file_dealers:
    'يبدو هذا الملف قائمة موزّعين. ارفع الموزّعين من الكتالوج → الاستيراد / التصدير → «قائمة الموزّعين».',
  wrong_file_redirects:
    'يبدو هذا الملف قائمة إعادة توجيه. ارفع عمليات إعادة التوجيه من النشاط التجاري → إعادة التوجيه → «الاستيراد من ملف».',
  sku_missing:
    'رمز SKU فارغ. أدخل رمز SKU في الملف أو استخدم «المعاينة مجددًا برموز SKU المقترحة» لاعتماد الاقتراح الموجود بين القوسين.',
  sku_generated: 'تم اقتراح SKU',
  media_not_failed: 'هذه الصورة ليست في حالة «فشل التنزيل».',
  wrong_file_categories:
    'يبدو هذا الملف قائمة فئات. ارفع الفئات من الكتالوج → الاستيراد / التصدير → «الفئات».',
  category_parent_unknown:
    'الفئة الأم غير موجودة (لا توجد فئة بهذا الاسم أو الاسم المختصر في الملف أو في النظام).',
  category_parent_ambiguous: 'توجد عدة فئات بهذا الاسم؛ اكتب الفئة الأم باسمها المختصر.',
  category_parent_has_errors: 'يحتوي صف الفئة الأم على خطأ؛ لذلك لن يُطبَّق هذا الصف أيضًا.',
  category_status_unknown: 'يجب أن تكون الحالة «etkin» (نشطة) أو «gizli» (مخفية).',
  category_changed_during_import: 'حُذفت فئة بعد المعاينة؛ ارفع الملف مرة أخرى.',
  category_will_create: 'سيتم إنشاء الفئة',
  store_archive_live: 'لا يمكن أرشفة متجر منشور مباشرةً؛ ضعه أولًا في وضع الصيانة أو أعده إلى المعاينة.',
  store_archived: 'المتجر مؤرشف؛ ألغِ أرشفته أولًا (سيعود إلى المعاينة).',
  store_not_draft: 'لا يمكن حذف متجر منشور أو في وضع الصيانة.',
  store_has_orders: 'لهذا المتجر طلبات ولا يمكن حذفه. يمكنك أرشفته.',
  store_has_scoped_access:
    'بعض المستخدمين أو الدعوات أو مفاتيح API مقيّدة بهذا المتجر فقط؛ غيّر نطاق المتجر الخاص بها أولًا.',
  confirm_code_mismatch: 'الرمز لا يطابق رمز المتجر.',
  transfer_source_empty:
    'لا يوجد في المستودع المصدر مخزون قابل للنقل من هذا المنتج. استخدم «حركة المخزون» → «استلام البضاعة» لأول إدخال للمخزون.',
  transfer_lot_required: 'المخزون في هذا المستودع محفوظ على شكل دفعات؛ اختر الدفعة كمصدر.',
  migration_package_invalid:
    'الملف ليس حزمة ترحيل أو أنه تالف. ارفع ملف ZIP الذي نزّلته عبر «تنزيل حزمة الترحيل» في بيئة Staging.',
  migration_package_too_large: 'الحزمة كبيرة جدًا (300 ميغابايت كحد أقصى بعد فك الضغط).',
  migration_file_missing: 'توجد صورة مفقودة في الحزمة ({{file}})؛ نزّل الحزمة مرة أخرى.',
  migration_file_corrupt: 'توجد صورة تالفة في الحزمة ({{file}})؛ نزّل الحزمة مرة أخرى.',
  store_scope_exceeds:
    'لا يمكنك تجاوز نطاق متاجرك: يمكنك منح المتاجر المخوّل بها فقط وإدارة مستخدمي هذه المتاجر.',
  member_self_update: 'لا يمكنك تغيير دورك أو نطاق متاجرك/موزّعيك بنفسك؛ يجب أن يقوم بذلك مسؤول آخر.',
  migration_file_type:
    'نوع أحد الملفات في الحزمة غير مسموح به أو لا يطابق محتواه نوعه ({{file}})؛ تُنقل الصور وملفات PDF فقط.',
  product_without_variant: 'لا يحتوي المنتج على صف متغيّر (SKU) صالح.',
  sku_belongs_to_other_product: 'رمز SKU هذا يخص منتجًا آخر.',
  brand_required: 'العلامة التجارية مطلوبة (في العمود أو كعلامة تجارية افتراضية).',
  brand_unknown: 'لا توجد علامة تجارية بهذا الاسم.',
  category_unknown: 'لا توجد فئة بهذا الاسم؛ أُضيف المنتج دون فئة.',
  species_unknown:
    'نوع الحيوان غير معروف. القيم المتاحة: cat (قط)، dog (كلب)، bird (طائر)، rodent (قارض/هامستر)، rabbit (أرنب)، reptile (زاحف/سلحفاة)، exotic (غريب) أو all (الكل)؛ افصل بين عدة قيم بفواصل.',
  tax_class_unknown: 'لا توجد فئة ضريبة قيمة مضافة بهذه النسبة؛ أنشئها أولًا.',
  visibility_unknown: 'يجب أن يكون الظهور «all» (الكل) أو «retail» (التجزئة) أو «dealer» (الموزّعون).',
  image_url_invalid: 'يجب أن يبدأ عنوان الصورة بـ https://.',
  duplicate_in_file: 'هذه القيمة موجودة أيضًا في الصف {{row}} من الملف.',
  amount_format: 'تعذّرت قراءة المبلغ (مثال: 1,299.90).',
  number_format: 'تعذّرت قراءة الرقم.',
  currency_unknown: 'تعذّر تحديد العملة.',
  status_unknown: 'يجب أن تكون الحالة «Approved» (معتمد) أو «Applied» (مقدَّم الطلب) أو «Suspended» (معلّق).',
  too_long: 'النص طويل جدًا.',
  too_many: 'عدد القيم كبير جدًا (الحد الأقصى {{column}}).',
  options_required_for_multiple_variants: 'تحتاج المتغيّرات المتعددة إلى خيار (مثل الحجم).',
  name_taken: 'هذا الاسم مستخدم بالفعل.',
  category_cycle: 'لا يمكن نقل فئة إلى إحدى فئاتها الفرعية.',
  category_has_children: 'لا يمكن حذف فئة لها فئات فرعية.',
  product_requires_active_variant: 'يحتاج المنتج النشط إلى متغيّر نشط واحد على الأقل.',
  vet_review_not_required: 'لا يحتوي هذا المنتج على محتوى صحي؛ لا حاجة إلى مراجعة بيطرية.',
  content_changed_during_review: 'تغيّر المحتوى أثناء مراجعتك. حدّث الصفحة وراجع المحتوى الحالي.',
  cannot_publish: 'لا يمكن نشر المنتج: {{reasons}}',
  invalid_option: 'يجب أن تكون قيمة الخيار إحدى القيم المعرَّفة.',
  duplicate_combination: 'لا يمكن أن يكون لمتغيّرين التركيبة نفسها من الخيارات.',
  mismatch: 'القائمة غير محدَّثة؛ حدّث الصفحة.',
  slug_format: 'يمكن أن يحتوي الاسم المختصر على أحرف صغيرة وأرقام وشرطات فقط.',
  sku_format: 'يمكن أن يحتوي رمز SKU على أحرف وأرقام و . _ - / فقط.',
  barcode_format: 'يجب أن يتكوّن الباركود من 8–14 رقمًا.',
  sku_taken: 'رمز SKU هذا مستخدم في متغيّر آخر.',
  store_not_ready: 'لم يتم تحديد سوق بيع (عملة) للمتجر بعد.',
  cart_line_limit: 'الحد الأقصى لعدد المنتجات المختلفة في السلة هو {{max}}.',
  variant_not_sellable: 'لا يمكن شراء هذا المنتج حاليًا.',
  insufficient_stock: 'المخزون غير كافٍ (الحد الأقصى {{available}}).',
  cart_empty: 'سلة التسوق فارغة.',
  empty: 'سلة التسوق فارغة.',
  cart_has_problems:
    'بعض المنتجات في السلة غير متاحة للبيع أو نفدت من المخزون أو لا تستوفي قاعدة الكمية الخاصة بالموزّعين؛ عدّل السلة.',
  payment_setup_required: 'لم يتم إعداد أي طريقة دفع بعد (يتطلب الإعداد). يرجى التواصل معنا لتقديم الطلب.',
  login_required: 'سجّل الدخول أو أنشئ حسابًا لتقديم الطلب.',
  dealer_only: 'حاليًا يمكن لموزّعينا فقط تقديم الطلبات.',
  checkout_not_allowed: 'لا يمكن تقديم الطلب حاليًا.',
  cart_changed: 'تغيّر إجمالي السلة (راجع الإجمالي الجديد). تحقّق وأكّد مرة أخرى.',
  refund_required: 'لا يمكن إلغاء طلب مدفوع دون استرداد المبلغ.',
  length: 'طول النص غير صالح.',
  discount_code_taken: 'رمز الخصم هذا موجود بالفعل.',
  discount_code_format: 'يتكوّن رمز الخصم من 3–32 حرفًا: أحرف وأرقام و - و _.',
  percentage_max: 'لا يمكن أن يتجاوز الخصم بالنسبة المئوية 100%.',
  currency_required: 'اختر عملة لرمز الخصم ذي المبلغ الثابت.',
  ends_before_start: 'يجب أن تكون النهاية بعد البداية.',
  discount_not_found: 'رمز الخصم غير صالح.',
  discount_not_started: 'رمز الخصم هذا غير ساري بعد.',
  discount_expired: 'انتهت صلاحية رمز الخصم هذا.',
  discount_usage_limit: 'بلغ رمز الخصم هذا حد الاستخدام.',
  discount_currency: 'رمز الخصم هذا غير صالح لعملة سلتك.',
  discount_not_eligible: 'رمز الخصم هذا غير صالح لحسابك.',
  discount_min_subtotal: 'إجمالي السلة أقل من المطلوب لاستخدام رمز الخصم هذا.',
  smtp_invalid_settings: 'إعدادات SMTP ناقصة أو غير صالحة.',
  error_tracking_invalid_dsn: 'قيمة DSN لتتبع الأخطاء غير صالحة.',
  error_tracking_failed: 'لم تقبل خدمة تتبع الأخطاء الحدث التجريبي.',
  observability_invalid: 'عنوان المُجمِّع أو ترويسات المصادقة غير صحيحة.',
  observability_failed: 'لم يقبل المُجمِّع حزمة الاختبار.',
  image_width: 'عرض الصورة غير مدعوم (160 أو 320 أو 480 أو 640 أو 960 أو 1280).',
  smtp_private_host_blocked: 'لا يمكن الاتصال بخادم SMTP على عنوان شبكة خاصة.',
  smtp_failed: 'فشل اتصال SMTP.',
  number: 'أدخل رقمًا.',
  unknown_field: 'حقل غير معروف.',
  not_supported: 'هذا الخيار غير مدعوم.',
  non_zero_integer: 'أدخل عددًا صحيحًا لا يساوي الصفر.',
  inactive: 'السجل غير نشط.',
  only_on_receipt: 'لا يمكن إنشاء الدفعات إلا عند استلام البضاعة.',
  must_be_positive: 'أدخل رقمًا موجبًا.',
  must_be_non_negative: 'أدخل رقمًا غير سالب.',
  same_warehouse: 'لا يمكن أن يكون المستودع المصدر والمستودع الهدف المستودع نفسه.',
  code_format: 'صيغة الرمز غير صالحة.',
  date_format: 'يجب أن يكون التاريخ بالصيغة YYYY-MM-DD.',
  etbis_url_invalid:
    'يجب أن يكون رابط ETBİS عنوانًا من موقع ETBİS التابع لوزارة التجارة التركية (https://etbis.eticaret.gov.tr/… أو https://etbis.ticaret.gov.tr/…).',
  days_pair_required: 'أدخل المدة الدنيا والمدة القصوى معًا.',
  days_range_invalid: 'لا يمكن أن تكون المدة الدنيا أكبر من المدة القصوى.',
  crawl_in_progress: 'يوجد بالفعل فحص زحف في قائمة الانتظار أو قيد التشغيل لهذا المتجر.',
  gtm_id_invalid: 'يجب أن يكون معرّف Google Tag Manager بالصيغة GTM-XXXXXXX.',
  ga4_id_invalid: 'يجب أن يكون معرّف القياس في GA4 بالصيغة G-XXXXXXXXXX (معرّفات UA- القديمة غير مدعومة).',
  google_ads_id_invalid: 'يجب أن يكون معرّف Google Ads بالصيغة AW-123456789.',
  google_ads_label_invalid: 'يمكن أن يحتوي تصنيف التحويل على أحرف وأرقام و - و _ فقط (6–40 حرفًا).',
  google_ads_id_required: 'أدخل معرّف Google Ads قبل تصنيف التحويل.',
  meta_pixel_id_invalid: 'يتكوّن معرّف بكسل Meta من أرقام فقط (8–20).',
  tiktok_pixel_id_invalid: 'يتكوّن معرّف بكسل TikTok من 10–30 حرفًا ورقمًا.',
  consent_action_mismatch: 'اختيارات ملفات تعريف الارتباط لا تتطابق مع الزر المستخدم.',
  google_client_not_configured:
    'لم يتم إعداد عميل Google OAuth أو لم يجتز الاختبار (يتطلب الإعداد). التكاملات → حساب Google (عميل OAuth).',
  google_not_connected: 'لا يوجد حساب Google متصل.',
  google_client_invalid: 'لم تقبل Google معرّف العميل أو السر.',
  google_client_invalid_format:
    'يجب أن ينتهي معرّف العميل بـ «.apps.googleusercontent.com»؛ ولا يمكن أن يكون السر فارغًا.',
  google_reconnect_required:
    'لم يعد الوصول إلى Google صالحًا (أُزيل أو انتهت صلاحيته). أعد الاتصال من شاشة Google.',
  google_signin_needs_domain:
    'يلزم الإعداد: يُجرى الاختبار بعنوان إعادة التوجيه الحقيقي للمتجر. أضف أولًا نطاقًا للواجهة من المتاجر.',
  google_invalid_request:
    'رفضت Google الطلب (invalid_request): {{description}} عنوان إعادة التوجيه المجرَّب: {{redirectUri}}. يجب أن يكون نطاقًا حقيقيًا بـ https ومدرجًا ضمن عناوين إعادة التوجيه المعتمدة للعميل في Google Cloud.',
  google_redirect_uri_mismatch:
    'عنوان إعادة التوجيه غير مسجّل في العميل على Google Cloud (redirect_uri_mismatch): {{redirectUri}}. أضفه من Google Auth Platform ← العملاء ← العميل ← عناوين إعادة التوجيه المعتمدة. {{description}}',
  google_client_rejected: 'رفضت Google الطلب ({{error}}): {{description}}',
  google_unreachable: 'تعذّر الوصول إلى Google. حاول مرة أخرى لاحقًا.',
  google_state_invalid:
    'استجابة Google غير صالحة أو منتهية الصلاحية (يجب أن يُكمل المستخدم الذي بدأ الاتصال العملية خلال 10 دقائق). اتصل مرة أخرى.',
  google_consent_denied: 'لم يُمنح الوصول في شاشة موافقة Google؛ لم يتغيّر شيء.',
  google_auth_failed: 'تعذّر إكمال الاتصال بـ Google. حاول مرة أخرى؛ وإذا استمرت المشكلة فراجع السجل.',
  google_scope_missing: 'لم تُمنح صلاحية Google لهذه الخدمة. أعد الاتصال مع تحديد الخدمة.',
  google_api_error: 'رفضت خدمة Google الطلب أو لم تستجب. راجع السجل.',
  google_permission_denied:
    'لا يملك حساب Google المرتبط صلاحية الوصول إلى هذا المورد. تحقّق من مشاركة المورد (الموقع أو الخاصية أو الحساب) مع حساب Google هذا، أو أعد الربط بحساب يملك الوصول.',
  google_api_not_enabled:
    'واجهة API لهذه الخدمة غير مفعّلة في مشروع Google Cloud. فعّلها من Google Cloud Console ← واجهات API والخدمات ← المكتبة (مشروع عميل OAuth المستخدم في اتصال Google).',
  google_quota_exceeded: 'تم بلوغ حد طلبات Google. أعد المحاولة بعد قليل؛ تُعاد محاولة المزامنة تلقائيًا.',
  google_resource_not_accessible:
    'هذا المورد غير موجود في قائمة الموارد التي يمكن لحساب Google المتصل الوصول إليها.',
  store_has_no_domain: 'ليس للمتجر نطاق لواجهة المتجر. أضف نطاقًا من شاشة المتاجر.',
  attribution_days: 'يجب أن تكون الفترة 7 أو 30 أو 90 أو 365 يومًا.',
  keyword_exists: 'هذه الكلمة المفتاحية موجودة بالفعل في المجموعة.',
  keyword_target_path:
    'يجب أن يكون الهدف مسارًا في واجهة المتجر يبدأ بـ «/» (مثل /urun/omega-3) ودون مسافات.',
  keyword_locale: 'يجب أن يتكوّن رمز اللغة من حرفين (مثل tr).',
  keyword_required: 'لا يمكن أن تكون الكلمة المفتاحية فارغة.',
  pagespeed_not_configured:
    'لم يُدخل مفتاح PageSpeed Insights أو لم يجتز الاختبار. التكاملات → PageSpeed Insights.',
  web_vitals_in_progress: 'يوجد قياس قيد التشغيل بالفعل لهذا المتجر. حاول مرة أخرى عند انتهائه.',
  pagespeed_key_format: 'صيغة مفتاح API غير صحيحة (Google Cloud → بيانات الاعتماد → مفتاح API).',
  pagespeed_key_invalid: 'لم تقبل Google مفتاح API هذا. يجب أن يكون PageSpeed Insights API مفعّلًا للمفتاح.',
  pagespeed_quota: 'نفدت الحصة اليومية لـ PageSpeed Insights. حاول مرة أخرى غدًا.',
  attribute_options_required: 'تحتاج السمة من نوع الاختيار إلى خيار واحد على الأقل.',
  attribute_options_duplicate: 'الخيار نفسه مكتوب مرتين.',
  attribute_name_taken: 'توجد بالفعل سمة بهذا الاسم.',
  attribute_code_taken: 'توجد بالفعل سمة بهذا الرمز.',
  attribute_type_locked: 'لا يمكن تغيير نوع سمة لها قيم في المنتجات. أنشئ سمة جديدة أو امسح القيم.',
  attribute_option_in_use: 'الخيار «{{option}}» مستخدم في منتجات؛ غيّره في تلك المنتجات أولًا.',
  attribute_in_collection: 'هذه السمة مستخدمة في قاعدة المجموعة «{{collection}}»؛ أزلها من القاعدة أولًا.',
  attribute_duplicate: 'السمة نفسها مُدخلة مرتين.',
  attribute_value_invalid: 'القيمة لا تناسب نوع هذه السمة (رقم أو خيار أو نعم/لا).',
  collection_rules_required: 'تحتاج المجموعة القائمة على القواعد إلى شرط واحد على الأقل.',
  collection_condition_invalid: 'شرط غير صالح: تحقّق من الحقل والمقارنة والقيمة.',
  synonym_terms_min: 'تحتاج المجموعة إلى مصطلحين مختلفين على الأقل.',
  synonym_single_word: 'يجب أن يكون كل مصطلح كلمة واحدة (دون مسافات أو علامات ترقيم).',
  synonym_term_taken: '«{{term}}» موجود في مجموعة مرادفات أخرى؛ لا يمكن أن يكون المصطلح إلا في مجموعة واحدة.',
  synonym_limit: 'يمكن تعريف 500 مجموعة مرادفات كحد أقصى.',
  search_report_days: 'يجب أن تكون الفترة 7 أو 30 أو 90 يومًا.',
  pagespeed_unreachable: 'تعذّر الوصول إلى PageSpeed Insights. حاول مرة أخرى لاحقًا.',
  server_event_id_required: 'أدخل أولًا معرّف هذا المزوّد (معرّف القياس / البكسل) في قسم وسوم واجهة المتجر.',
  server_event_secret_required: 'أدخل السر (API secret / رمز الوصول) لتفعيل أحداث الخادم.',
  server_test_code_required: 'للاختبار، أدخل رمز الاختبار من شاشة «أحداث الاختبار» لدى المزوّد.',
  server_event_not_retryable: 'لا يمكن إعادة محاولة إلا الأحداث الفاشلة أو المتخطاة.',
  server_secret_format: 'يجب ألا يقل السر عن 8 أحرف وألا يحتوي على مسافات.',
  server_test_code_format: 'يمكن أن يحتوي رمز الاختبار على أحرف وأرقام و - و _ فقط.',
  merchant_not_linked: 'لم يتم اختيار حساب Merchant Center لهذا المتجر. اتصالات Google → موارد المتجر.',
  search_console_not_linked: 'لم يتم اختيار موقع Search Console لهذا المتجر. اتصالات Google → موارد المتجر.',
  inspection_quota_exceeded: 'نفد حد فحص عناوين URL لهذا اليوم ({{limit}}). حاول مرة أخرى غدًا.',
  sitemap_not_in_property: 'نطاق المتجر غير مشمول في موقع Search Console المحدد.',
  url_not_in_property: 'يجب أن يكون العنوان ضمن نطاق هذا المتجر وفي موقع Search Console المحدد.',
  date_range_invalid: 'لا يمكن أن يكون تاريخ الانتهاء قبل تاريخ البدء.',
  export_too_large: 'يوجد أكثر من {{max}} صف في هذه الفترة. اختر فترة أقصر.',
  unknown_role: 'دور غير معروف.',
  unknown: 'قيمة غير معروفة.',
  unknown_brand: 'علامة تجارية غير معروفة.',
  unknown_market: 'هذا السوق لا يتبع هذا المتجر.',
  mersis_format: 'يجب أن يتكوّن رقم MERSIS من 16 رقمًا.',
  hostname_format: 'اسم النطاق غير صالح (مثل zootopia.com.tr).',
  currency_locked: 'لا يمكن تغيير عملة قائمة تحتوي على أسعار.',
  currency_mismatch: 'العملات غير متطابقة.',
  bulk_no_targets:
    'لا توجد منتجات تطابق التحديد (في إجراءات الأسعار: لا توجد منتجات لها سعر). غيّر التحديد أو عامل التصفية.',
  bulk_not_in_preview: 'هذه العملية الجماعية ليست في مرحلة المعاينة.',
  bulk_preview_expired: 'انتهت صلاحية المعاينة (30 دقيقة). أعد المعاينة.',
  prices_changed_since_preview: 'تغيّرت الأسعار بعد المعاينة. أعد المعاينة.',
  bulk_not_applied: 'لم تُطبَّق هذه العملية الجماعية؛ لذا لا يمكن التراجع عنها.',
  ledger_entry_not_reversible:
    'لا يمكن عكس هذا القيد. قيود الطلبات تتبع الطلب نفسه (الإلغاء، الاسترداد، التعديل)؛ ولا يمكن عكس القيد العكسي.',
  ledger_entry_already_reversed: 'تم عكس هذا القيد بالفعل.',
  date_invalid: 'أدخل تاريخًا صالحًا.',
  report_period_too_long: 'يمكن أن تكون فترة التقرير سنة واحدة كحد أقصى.',
  balance_payment_unavailable:
    'الدفع بالبطاقة غير متاح حاليًا. يمكنك سداد رصيدك بتحويل بنكي أو التواصل مع مندوب المبيعات الخاص بك.',
  balance_payment_nothing_due: 'لا يوجد رصيد مستحق للدفع.',
  balance_payment_item_closed: 'أحد البنود المحددة مغلق أو تغيّر. حدّث الصفحة وحدّد مرة أخرى.',
  balance_payment_exceeds_balance: 'لا يمكن أن يتجاوز المبلغ الرصيد المستحق (الحد الأقصى {{max}}).',
  balance_payment_too_small: 'يجب ألا يقل المبلغ عن 1.00.',
  balance_payment_items_required: 'حدّد بندًا واحدًا على الأقل للدفع.',
  bank_import_columns:
    'لا يحتوي كشف الحساب البنكي على عمودي التاريخ والمبلغ (أو الدائن). نزّل حركات الحساب من بنكك بصيغة CSV أو Excel (XLSX)؛ الأعمدة المطلوبة: {{required}}.',
  bank_line_not_found: 'هذا السطر غير موجود في الكشف؛ أعد المعاينة.',
  bank_line_blocked:
    'لا يمكن ترحيل هذا السطر (تعذّرت قراءة المبلغ/التاريخ، أو التاريخ في المستقبل، أو سبق ترحيله).',
  bank_line_duplicate: 'تم ترحيل هذه الحركة البنكية إلى دفتر الحسابات من قبل.',
  bank_dealer_not_found: 'الموزّع المحدد غير موجود أو غير معتمد.',
  ledger_import_columns: 'أعمدة مطلوبة مفقودة: {{required}}. استخدم عناوين الأعمدة الموجودة في القالب.',
  ledger_import_not_in_preview: 'هذا الاستيراد ليس في مرحلة المعاينة (تم تطبيقه أو انتهت صلاحيته).',
  ledger_import_expired: 'انتهت صلاحية المعاينة (ساعة واحدة). ارفع الملف مرة أخرى.',
  ledger_import_empty: 'لا توجد صفوف صالحة للاستيراد.',
  credit_limit_exceeded: 'مبلغ الطلب يتجاوز حد الائتمان للحساب الآجل.',
  credit_overdue_block: 'تم إيقاف الطلبات الجديدة على الحساب الآجل بسبب ديون متأخرة السداد.',
  credit_limit_currency: 'حد الائتمان محدد بعملة أخرى؛ الحساب الآجل غير متاح بهذه العملة.',
  quote_cart_locked: 'تحتوي السلة على عرض سعر مقبول؛ أزل عرض السعر من السلة لتتمكن من تعديلها.',
  quote_closed: 'عرض السعر هذا مغلق (تحوّل إلى طلب أو رُفض أو أُلغي) ولا يمكن تعديله.',
  quote_not_acceptable: 'عرض السعر هذا غير متاح للقبول أو الرفض حاليًا.',
  quote_expired: 'انتهت صلاحية عرض السعر. تواصل مع المتجر للحصول على عرض سعر جديد.',
  quote_unavailable: 'عرض السعر الموجود في السلة لم يعد صالحًا (أُلغي أو أُغلق). أزله من السلة.',
  quote_changed: 'تم تحديث عرض السعر؛ افتح صفحة عرض السعر لمشاهدة النسخة الجديدة وقبولها.',
  quote_lines_required: 'يحتاج عرض السعر إلى منتج واحد على الأقل.',
  dealer_not_approved: 'الموزّع غير معتمد أو ليس لديه مجموعة موزّعين.',
  quantity_below_minimum: 'الحد الأدنى لطلب الموزّعين من هذا المنتج هو {{min}}.',
  quantity_not_multiple:
    'يُباع هذا المنتج في كراتين تحتوي كل منها على {{step}}؛ يجب أن تكون الكمية من مضاعفات حجم الكرتونة.',
  min_order_not_met: 'إجمالي السلة أقل من الحد الأدنى لمبلغ طلب الموزّعين.',
  reorder_nothing: 'لا يوجد في هذا الطلب ما يمكن إضافته إلى السلة.',
  company_viewer_cannot_order:
    'حساب شركتك للعرض فقط؛ لا يمكنك تقديم الطلبات. يمكن للمسؤول المفوّض في الشركة أو لمستخدم المشتريات تقديم الطلب.',
  member_order_limit_exceeded:
    'إجمالي الطلب يتجاوز الحد المسموح لك؛ يتطلب طلب بهذا المبلغ موافقة المسؤول المفوّض في الشركة. أرسل السلة لموافقته أو قلّل مبلغها.',
  approval_not_needed:
    'لا تحتاج هذه السلة إلى موافقة الشركة؛ لا يرسل السلال للموافقة إلا مستخدم المشتريات الذي لديه حد للطلبات.',
  approval_already_granted: 'تمت الموافقة على السلة بالفعل؛ يمكنك إتمام الطلب.',
  approval_closed: 'تم البت في طلب الموافقة هذا بالفعل.',
  approval_stale:
    'تغيّرت السلة بعد إرسالها للموافقة، لذا لا يمكن الموافقة على هذا الطلب. يجب على مستخدم المشتريات إرسال السلة الحالية مرة أخرى.',
  rejection_reason_required: 'أدخل سببًا للرفض (3 أحرف على الأقل).',
  po_number_required: 'تشترط شركتك إدخال رقم أمر الشراء (PO) في الطلبات.',
  po_document_required: 'تشترط شركتك إرفاق مستند أمر الشراء (PO) بالطلبات؛ ارفع المستند.',
  po_number_format: 'يحتوي رقم PO على أحرف غير مسموح بها.',
  dealer_scope_role_incompatible:
    'لا يمكن استخدام نطاق «الموزّعون المعيَّنون فقط» مع هذا الدور: فالدور يتيح الوصول إلى بيانات خارج نطاق الموزّعين (مثل تذاكر الدعم والتسويق وسجل التدقيق).',
  customer_email_taken: 'هذا البريد الإلكتروني مسجّل في حساب عميل آخر.',
  dealer_scope_restricted:
    'يؤثر هذا الإجراء في جميع الموزّعين؛ ونطاق الموزّعين الخاص بك هو «الموزّعون المعيَّنون فقط»، لذا لا يمكنك تنفيذه.',
  region_name_taken: 'توجد بالفعل منطقة بهذا الاسم.',
  commission_later_period_exists:
    'توجد كشوف لفترة لاحقة بالفعل؛ تُحتسب الفترات بالترتيب. ستظهر التغييرات في هذه الفترة كتسويات في الفترة التالية.',
  commission_statement_not_draft: 'الكشف ليس مسودة؛ لا يمكن تغيير الكشوف المعتمدة أو المدفوعة.',
  commission_statement_not_approved: 'اعتمد الكشف قبل وضع علامة «مدفوع» عليه.',
  period_in_future: 'لا يمكن احتساب فترة لم تبدأ بعد.',
  sales_user_invalid: 'المستخدم المحدد ليس عضوًا نشطًا في هذا النشاط التجاري ممن يمكنهم رؤية الموزّعين.',
  company_invite_mail_required:
    'يلزم الإعداد: لا يمكن إرسال الدعوات لأن خدمة البريد الإلكتروني للمتجر غير مُعدّة.',
  company_invite_limit: 'وصلت إلى حدّ الدعوات لليوم ({{max}})؛ حاول مجددًا غدًا.',
  company_invite_existing_account:
    'يوجد في المتجر حساب بهذا البريد الإلكتروني. لإضافة هذا الشخص إلى شركتك، تواصل مع المتجر.',
  company_member_self: 'لا يمكنك تغيير دورك أو إزالة نفسك من الشركة؛ تواصل مع المتجر لذلك.',
  company_member_already_active: 'فعّل هذا المستخدم حسابه بالفعل.',
  company_link_limit: 'يمكن إرسال {{max}} روابط كحد أقصى لهذا المستخدم يوميًا؛ حاول مجددًا غدًا.',
  company_last_owner:
    'يجب أن يبقى في الشركة مسؤول مفوّض واحد على الأقل. اجعل مستخدمًا آخر مسؤولًا مفوّضًا أولًا.',
  location_limit: 'الحد الأقصى لعدد مواقع الشركة هو {{max}}.',
  reminder_confirm_required:
    'تفعيل تذكيرات الدفع يرسل رسائل بريد إلكتروني حقيقية إلى موزّعيك. حدّد مربع التأكيد لتفعيلها.',
  must_be_after_start: 'يجب أن تكون النهاية بعد البداية.',
  net_quantity_unit_pair: 'أدخل الكمية الصافية والوحدة معًا.',
  payment_method_unavailable: 'طريقة الدفع هذه غير متاحة حاليًا.',
  shipping_method_unavailable: 'طريقة الشحن المحددة غير متاحة لهذه السلة.',
  cod_not_available_for_shipping: 'الدفع عند الاستلام غير متاح لطريقة الشحن المحددة.',
  cod_limit_exceeded: 'إجمالي الطلب يتجاوز حد الدفع عند الاستلام.',
  legal_setup_required: 'لا يمكن استقبال الطلبات قبل نشر نموذج المعلومات المسبقة وعقد البيع عن بُعد.',
  legal_changed: 'تم تحديث نصوص العقود. يرجى قراءة النص الجديد والموافقة عليه.',
  payment_retry_not_allowed: 'لا يمكن إعادة محاولة الدفع لهذا الطلب.',
  use_payment_capture: 'لا يصبح الطلب «مدفوعًا» إلا عبر سجل دفع (استخدم «تم استلام الدفعة»).',
  payment_required_before_shipping: 'لا يمكن شحن طلب غير مدفوع.',
  bizimhesap_credentials_missing: 'معرّف الشركة في BizimHesap (firmId) غير مُدخل.',
  bizimhesap_auth_failed: 'رفضت BizimHesap بيانات الاعتماد. تحقّق من معرّف الشركة/المفتاح.',
  bizimhesap_unreachable: 'تعذّر الوصول إلى BizimHesap. حاول مرة أخرى لاحقًا.',
  bizimhesap_redirected:
    'أعادت BizimHesap توجيه الطلب (HTTP {{status}} → {{location}}). ربما تغيّر عنوان API الخاص بـ BizimHesap؛ تحتاج المنصة إلى تحديث.',
  bizimhesap_unexpected_response:
    'أعادت BizimHesap استجابة غير متوقعة (HTTP {{status}}، {{contentType}})؛ الاستجابة ليست JSON. قد تكون الخدمة قيد الصيانة أو ربما تغيّر عنوان API.',
  bizimhesap_timeout: 'لم تستجب BizimHesap خلال 20 ثانية. حاول مرة أخرى لاحقًا.',
  bizimhesap_api_error: 'رفضت BizimHesap الطلب: {{message}}',
  bizimhesap_shape_unknown:
    'لم يتم التعرّف على حقول استجابة BizimHesap ({{endpoint}}). حُفظت عيّنة مقنّعة في صفحة BizimHesap؛ يجب تحديث ربط الحقول.',
  invoice_provider_cancel_not_pending: 'لا يوجد إلغاء معلّق في BizimHesap لهذه الفاتورة ({{state}}).',
  bizimhesap_customer_unmatched:
    'الموزّع غير مرتبط بحساب جارٍ في BizimHesap ({{company}}). اربطه من التكاملات → BizimHesap → استيراد الحسابات؛ فالفاتورة المرسلة برمز غير معروف ستنشئ حسابًا جديدًا في BizimHesap.',
  bizimhesap_cash_unmapped:
    'لم يتم اختيار حساب صندوق في BizimHesap لطريقة الدفع الخاصة بهذا الطلب المدفوع. اختره من التكاملات → BizimHesap → حسابات الصندوق.',
  bizimhesap_cash_unknown: 'حساب الصندوق هذا غير موجود في قائمة BizimHesap. حدّث القائمة أولًا.',
  bizimhesap_write_confirm_required:
    'تفعيل الكتابة إلى BizimHesap ينشئ سجلات في حسابك المحاسبي الحقيقي. حدّد مربع التأكيد لتفعيلها.',
  bizimhesap_customer_not_found: 'رمز الحساب هذا غير موجود في قائمة حسابات BizimHesap.',
  bizimhesap_code_duplicate: 'لا يمكن إعطاء رمز الحساب نفسه لموزّعَين.',
  bizimhesap_code_taken: 'رمز الحساب هذا ({{code}}) مرتبط بموزّع آخر.',
  bizimhesap_writes_disabled:
    'الكتابة إلى BizimHesap متوقفة. يمكن للمالك أو المدير تفعيلها من التكاملات → BizimHesap → الكتابة إلى BizimHesap.',
  bizimhesap_collection_not_sendable: 'لا يمكن إرسال إلا التحصيلات المعلّقة أو الفاشلة.',
  bizimhesap_collection_not_uncertain: 'لا يمكن حسم إلا التحصيلات ذات النتيجة غير المؤكدة.',
  bizimhesap_correction_not_found: 'الفاتورة المحددة غير موجودة في قائمة التصحيح.',
  invoice_not_allowed: 'لا يمكن إنشاء فاتورة لهذا الطلب (مسودة أو ملغى).',
  invoice_exists: 'لهذا الطلب فاتورة صالحة بالفعل.',
  invoice_not_sendable: 'لا يمكن إرسال إلا الفواتير المسودة أو الفاشلة.',
  invoice_not_uncertain: 'الفاتورة ليست في حالة «غير مؤكد».',
  invoice_not_cancellable: 'لا يمكن إلغاء هذه الفاتورة.',
  legal_no_draft: 'لا توجد مسودة للنشر.',
  legal_unknown_variable: 'يحتوي النص على متغيّر غير معرَّف لنوع المستند هذا.',
  legal_required_variables_missing: 'المتغيّرات المطلوبة مفقودة من النص.',
  legal_placeholder_syntax: 'صيغة المتغيّر غير صحيحة: اكتب {{field.name}}.',
  iyzico_credentials_missing: 'مفتاح API والمفتاح السري لـ iyzico غير مُدخلين.',
  iyzico_not_sandbox_key: 'تحتاج بيئة الاختبار إلى مفتاح اختبار iyzico يبدأ بـ «sandbox-».',
  iyzico_sandbox_key_in_live: 'تم إدخال مفتاح اختبار (Sandbox) للبيئة المباشرة.',
  iyzico_auth_failed: 'رفضت iyzico المفاتيح.',
  iyzico_unreachable: 'تعذّر الوصول إلى iyzico. حاول مرة أخرى لاحقًا.',
  paytr_credentials_missing: 'معرّف التاجر ومفتاح التاجر وقيمة salt في PayTR غير مُدخلة.',
  paytr_auth_failed: 'رفضت PayTR بيانات الاعتماد.',
  paytr_unreachable: 'تعذّر الوصول إلى PayTR. حاول مرة أخرى لاحقًا.',
  stripe_ok: 'تم التحقق من اتصال Stripe (تمت قراءة الرصيد).',
  stripe_credentials_missing: 'المفتاح السري لـ Stripe ومفتاح توقيع Webhook غير مُدخلين.',
  stripe_key_invalid:
    'يجب أن يبدأ المفتاح السري بـ «sk_» (أو المفتاح المقيّد «rk_»)، وليس المفتاح القابل للنشر «pk_».',
  stripe_not_test_key: 'تحتاج بيئة الاختبار إلى مفتاح اختبار يبدأ بـ «sk_test_».',
  stripe_test_key_in_live: 'تم إدخال مفتاح اختبار للبيئة المباشرة (المطلوب «sk_live_»).',
  stripe_webhook_secret_invalid:
    'يجب أن يبدأ مفتاح توقيع Webhook بـ «whsec_» (Stripe → Webhooks → نقطة النهاية).',
  stripe_mode_mismatch: 'وضع المفتاح (اختبار/مباشر) لا يطابق البيئة المحددة.',
  stripe_auth_failed: 'لم تقبل Stripe المفتاح.',
  stripe_unreachable: 'تعذّر الوصول إلى Stripe. حاول مرة أخرى لاحقًا.',
  sipay_ok: 'تم التحقق من اتصال Sipay (تم استلام رمز الوصول).',
  sipay_credentials_missing: 'لم يتم إدخال معرّف التطبيق والمفتاح السري للتطبيق ومفتاح التاجر في Sipay.',
  sipay_auth_failed: 'لم تُقبل بيانات اعتماد Sipay.',
  sipay_unreachable: 'تعذّر الوصول إلى Sipay. حاول مرة أخرى لاحقًا.',
  google_other_account_linked:
    'حساب هذا البريد مرتبط بحساب Google آخر. سجّل الدخول بذلك الحساب أو ببريدك وكلمة المرور.',
  google_signin_unavailable:
    'تسجيل الدخول عبر Google غير مفعّل في هذا المتجر. سجّل الدخول ببريدك وكلمة المرور.',
  google_signin_state_invalid:
    'انتهت صلاحية طلب تسجيل الدخول عبر Google أو لم يبدأ في هذا المتصفح. أعد المحاولة بـ«المتابعة باستخدام Google».',
  google_signin_denied: 'أُلغي تسجيل الدخول عبر Google.',
  google_signin_failed: 'تعذّر إكمال تسجيل الدخول عبر Google. أعد المحاولة.',
  google_signin_client_invalid: 'رُفض عميل تسجيل الدخول عبر Google الخاص بالمتجر. تواصل مع المتجر.',
  google_token_invalid: 'تعذّر التحقق من هوية Google. أعد المحاولة.',
  google_email_unverified: 'البريد الإلكتروني لحساب Google غير مؤكَّد. سجّل أو ادخل ببريدك وكلمة المرور.',
  google_dealer_not_allowed:
    'لا يمكن لحسابات الوكلاء تسجيل الدخول عبر Google. سجّل الدخول ببريدك وكلمة المرور.',
  google_signin_account_disabled: 'هذا الحساب معطّل. تواصل مع المتجر.',
  google_signin_retry: 'أُجري للتو إجراء آخر بحساب Google هذا. أعد المحاولة بـ«المتابعة باستخدام Google».',
  google_signup_expired: 'انتهت صلاحية تأكيد التسجيل عبر Google. ابدأ من جديد بـ«المتابعة باستخدام Google».',
  google_signin_owner_only: 'يمكن لمالك النشاط فقط تفعيل تسجيل الدخول عبر Google.',
  google_signin_not_configured: 'احفظ عميل OAuth واختبره أولًا من التكاملات ← تسجيل الدخول عبر Google.',
  google_timeout: 'لم تستجب Google في الوقت المناسب. أعد المحاولة.',
  password_required_before_unlink: 'عيّن كلمة مرور لحسابك قبل إزالة ربط Google؛ وإلا فلن تتمكن من الدخول.',
  google_reauth_required:
    'لحماية حسابك، سجّل الدخول باستخدام Google مرة أخرى قبل تعيين كلمة المرور؛ يمكنك تعيينها خلال 15 دقيقة من تسجيل الدخول.',
  privacy_password_required:
    'يتم تأكيد هذا الإجراء بكلمة المرور. أُنشئ حسابك باستخدام Google، لذا عيّن أولًا كلمة مرور من حسابي ← الحسابات المرتبطة.',
  dealer_application_password_required:
    'لا يمكن تقديم طلب وكالة في جلسة مسجّلة عبر Google. سجّل الدخول ببريدك وكلمة المرور (عيّن كلمة مرور من حسابي ← الحسابات المرتبطة إن لم تكن لديك).',
  geliver_credentials_missing: 'لم يتم إدخال رمز API الخاص بـ Geliver.',
  geliver_auth_failed: 'رفضت Geliver رمز API. تحقّق من الرمز في لوحة Geliver (رموز API).',
  geliver_timeout: 'لم تستجب Geliver خلال 30 ثانية. حاول مرة أخرى لاحقًا.',
  geliver_unreachable: 'تعذّر الوصول إلى Geliver. حاول مرة أخرى لاحقًا.',
  geliver_unavailable:
    'لا تستطيع Geliver الاستجابة الآن (HTTP {{status}}). حاول بعد بضع دقائق؛ لن يُشترى الملصق مرتين.',
  geliver_rejected: 'رفضت Geliver الطلب: {{reason}}',
  geliver_unexpected_response: 'أعادت Geliver استجابة غير متوقعة؛ لم تكتمل العملية.',
  geliver_not_connected: 'Geliver غير متصلة. أدخل رمز API من التكاملات ← الشحن ← Geliver واختبر الاتصال.',
  geliver_sender_required: 'لم يتم اختيار عنوان مرسل في Geliver. اختره من الشحن ← Geliver.',
  geliver_sender_unknown: 'لم يُعثر على عنوان المرسل هذا في Geliver.',
  geliver_cod_unsupported:
    'لا يمكن حاليًا شحن طلبات الدفع عند الاستلام عبر Geliver؛ اشحنها يدويًا برقم تتبع.',
  geliver_domestic_only: 'يمكن الشحن عبر Geliver إلى عناوين داخل تركيا فقط.',
  geliver_address_city_unknown: 'لم يتم التعرّف على المحافظة في عنوان التسليم. صحّح عنوان الطلب.',
  geliver_address_district_required:
    'عنوان التسليم بلا منطقة أو المنطقة ليست في هذه المحافظة. شركة الشحن تتطلب المنطقة؛ صحّح عنوان الطلب.',
  geliver_phone_required: 'لا يحتوي عنوان التسليم على رقم هاتف صالح. شركة الشحن تتطلب هاتف المستلم.',
  geliver_shipment_mismatch: 'شحنة Geliver هذه لا تخص هذا الطلب.',
  geliver_shipment_cancelled: 'أُلغيت شحنة Geliver هذه. اطلب العروض مرة أخرى.',
  geliver_other_offer_accepted: 'تم قبول عرض آخر لهذه الشحنة في Geliver بالفعل.',
  geliver_offer_unknown: 'العرض المختار ليس ضمن هذه الشحنة. حدّث العروض.',
  geliver_not_a_geliver_shipment: 'لم تُنشأ هذه الشحنة عبر Geliver.',
  geliver_cancel_after_pickup:
    'بعد استلام شركة الشحن للطرد لا يمكن الإلغاء من هنا؛ تواصل مع Geliver أو شركة الشحن.',
  geliver_cancel_via_provider:
    'ألغِ الشحنة التي اشتُري ملصقها عبر Geliver بزر «الإلغاء في Geliver» (تُسترد رسوم الملصق عبر Geliver).',
  geliver_dimension_invalid: 'يجب أن تكون الأبعاد أعدادًا صحيحة بين 1 و300 سم.',
  paypal_ok: 'تم التحقق من اتصال PayPal (تم العثور على Webhook).',
  paypal_credentials_missing: 'معرّف العميل والسر ومعرّف Webhook في PayPal غير مُدخلة.',
  paypal_auth_failed: 'لم تقبل PayPal معرّف العميل أو السر.',
  paypal_webhook_not_found: 'لم يتم العثور على معرّف Webhook هذا في تطبيق PayPal الخاص بك.',
  paypal_unreachable: 'تعذّر الوصول إلى PayPal. حاول مرة أخرى لاحقًا.',
  reconcile_provider_error: 'تعذّر جلب تقرير المعاملات من المزوّد.',
  payment_token_mismatch: 'بيانات الدفع غير متطابقة.',
  card_payment_required: 'لا تُؤكَّد المدفوعات بالبطاقة إلا عبر تحقق المزوّد.',
  already_paid: 'تم استلام دفعة هذا الطلب بالفعل.',
  refund_exceeds_payment: 'مبلغ الاسترداد يتجاوز المبلغ القابل للاسترداد.',
  no_captured_payment: 'لا توجد دفعة محصّلة لهذا الطلب.',
  refund_in_progress: 'توجد عملية استرداد جارية بالفعل لهذه الدفعة.',
  amount_mismatch: 'المبلغ الذي أبلغ عنه المزوّد لا يطابق إجمالي الطلب. تحقّق من لوحة تحكم المزوّد.',
  amount_unverified: 'لم يُبلغ المزوّد عن المبلغ؛ تعذّر التحقق من الدفعة. تحقّق من لوحة تحكم المزوّد.',
  test_mode_payment:
    'عالجت PayTR هذه المعاملة في وضع الاختبار؛ لم يتم تحصيل أي أموال. أكمل خطوة «Live Mode» في PayTR وألغِ هذا الطلب.',
  provider_review:
    'الدفعة قيد مراجعة الاحتيال لدى المزوّد. يتم التحقق من النتيجة كل ساعة؛ ويبقى الطلب مفتوحًا.',
  provider_review_stale:
    'لم تنتهِ مراجعة المزوّد خلال 7 أيام. تحقّق من لوحة تحكم المزوّد وأنهِ الطلب يدويًا.',
  provider_unreachable:
    'تعذّر التحقق من نتيجة الدفع لأنه تعذّر الوصول إلى المزوّد. تحقّق من لوحة تحكم المزوّد وأنهِ الطلب يدويًا.',
  payment_timeout: 'انتهت مهلة الدفع؛ تم إلغاء الطلب.',
  bank_transfer_timeout: 'لم يصل التحويل البنكي في الوقت المحدد؛ تم إلغاء الطلب.',
  redirect_from_invalid:
    'العنوان القديم غير صالح: يجب أن يكون مسارًا يبدأ بـ «/» (لا يمكن إعادة توجيه الصفحة الرئيسية ومسارات النظام).',
  redirect_host_invalid:
    'نطاق المصدر غير صالح: اكتب نطاقًا مثل «zootopiaglobal.com» أو اتركه فارغًا لكل النطاقات.',
  redirect_to_invalid:
    'العنوان الجديد غير صالح: يجب أن يكون مسارًا يبدأ بـ «/» أو عنوانًا كاملًا يبدأ بـ https://.',
  redirect_loop: 'العنوان الجديد مطابق للعنوان القديم؛ ستتسبب إعادة التوجيه في حلقة.',
  redirect_exists: 'توجد إعادة توجيه بالفعل لهذا العنوان القديم.',
  redirect_import_columns: 'لا يحتوي الملف على عمودي «العنوان القديم» و«العنوان الجديد». استخدم القالب.',
  redirect_status_invalid: 'يجب أن يكون الرمز 301 أو 302.',
  redirect_duplicate_row: 'يتكرر هذا العنوان القديم أكثر من مرة في الملف.',
  redirect_import_has_errors: 'عدد الصفوف التي تحتوي على أخطاء في الملف: {{count}}؛ لم يُحفظ أي شيء.',
  store_status_use_launch: 'لا تتغيّر حالة النشر من نموذج المتجر؛ استخدم تفاصيل المتجر → حالة النشر.',
  store_launch_incomplete: 'توجد بنود مطلوبة ناقصة في قائمة الجاهزية؛ أكملها قبل النشر المباشر.',
  return_not_allowed: 'لا يمكن إنشاء طلب إرجاع لهذا الطلب (طلب غير مدفوع أو ملغى).',
  return_already_open: 'يوجد بالفعل طلب إرجاع مفتوح لهذا الطلب؛ انتظر حتى يتم البت فيه.',
  return_line_invalid: 'المنتج المحدد غير موجود في هذا الطلب.',
  return_quantity_exceeds: 'لا يمكن أن تتجاوز كمية الإرجاع الكمية المطلوبة.',
  refund_not_pending: 'اكتملت عملية الاسترداد هذه بالفعل.',
  refund_still_running:
    'قد تكون عملية الاسترداد لا تزال جارية. انتظر {{minutes}} دقيقة بعد بدئها قبل إنهائها يدويًا.',
  store_live_requires_live_payments:
    'لا يمكن تحويل المدفوعات بالبطاقة إلى بيئة الاختبار أثناء نشر المتجر. أوقف نشر المتجر أولًا.',
  refund_note_required: 'أدخل ملاحظة للاسترداد اليدوي (مثل رقم IBAN الذي تم الاسترداد إليه والتاريخ).',
  restock_only_after_shipping: 'لا يمكن إعادة المنتجات إلى المخزون إلا للطلبات المشحونة.',
  card_provider_not_connected: 'يجب أن ينجح اختبار الاتصال بمزوّد البطاقات لهذه البيئة.',
  live_requires_sandbox_payment:
    'يلزم إجراء دفعة تجريبية ناجحة واحدة على الأقل قبل الانتقال إلى البيئة المباشرة.',
  iban_taken: 'رقم IBAN هذا مسجّل بالفعل.',
  staging_allowlist: 'تم الحظر في بيئة Staging: المستلم غير موجود في قائمة البريد الإلكتروني المسموح بها.',
  mail_allowlist_entry_invalid:
    'إدخال غير صالح: أدخل عنوان بريد إلكتروني كاملًا (name@example.com) أو نطاقًا (@example.com).',
  iban_invalid: 'رقم IBAN غير صالح (26 حرفًا تبدأ بـ TR مع رقم تحقق صحيح).',
  tiers_not_ascending: 'يجب ترتيب شرائح الوزن تصاعديًا.',
  shipment_closed: 'هذه الشحنة مغلقة (تم تسليمها/إرجاعها/إلغاؤها).',
  https_url_required: 'يجب أن يبدأ العنوان بـ https://.',
  shipping_setup_required: 'لا يمكن استقبال الطلبات قبل إعداد طريقة شحن.',
  setup_step_required: 'لا يمكن تخطي خطوة النشر المباشر؛ تكتمل تلقائيًا عند نشر المتجر.',
  // F7-19: düzenli sipariş
  subscriptions_disabled: 'التوصيل المنتظم معطّل في هذا المتجر.',
  product_not_subscribable: 'هذا المنتج لا يُباع بالتوصيل المنتظم.',
  subscription_interval_invalid: 'لا يمكن اختيار هذا التكرار؛ اختر إحدى الفترات المعروضة.',
  subscription_address_required: 'أضف عنوان توصيل في «حسابي» للتوصيل المنتظم.',
  subscription_limit: 'يمكنك امتلاك 20 توصيلًا منتظمًا نشطًا كحد أقصى؛ ألغِ واحدًا وحاول مجددًا.',
  subscription_out_of_stock: 'لا يتوفر مخزون كافٍ لهذه الكمية؛ قلّل الكمية أو حاول لاحقًا.',
  subscription_start_failed: 'تعذّر بدء التوصيل المنتظم؛ يُرجى المحاولة بعد قليل.',
  subscription_cancelled: 'تم إلغاء هذا التوصيل المنتظم.',
  subscription_not_active: 'هذا ممكن فقط لتوصيل منتظم نشط.',
  subscription_not_paused: 'يمكن استئناف التوصيل المنتظم المتوقف مؤقتًا فقط.',
  subscription_postpone_range: 'يمكن أن يكون التاريخ الجديد من الغد حتى 12 أسبوعًا.',
  subscription_nothing_to_pay: 'لا يوجد طلب بانتظار الدفع.',
  customer_inactive: 'حساب العميل غير نشط.',
  pricing_failed: 'تعذّر حساب مبلغ الطلب؛ يُرجى المحاولة بعد قليل.',
};
